import React from "react";
import { Link } from "react-router-dom";
import FooterOne from "../common/footer/FooterOne";
import HeaderTwo from "../common/header/HeaderTwo";
import SEO from "../common/SEO";
import BannerTwo from "../component/banner/BannerTwo";
import BlogOne from "../component/blog/BlogOne";
import BrandOne from "../component/brand/BrandOne";
import CounterUpOne from "../component/counterup/CounterUpOne";
import CtaLayoutOne from "../component/cta/CtaLayoutOne";
import ProjectOne from "../component/project/ProjectOne";
import ServicePropOne from "../component/service/ServicePropOne";
import TestimonialOne from "../component/testimonial/TestimonialOne";
import SectionTitle from "../elements/section-title/SectionTitle";
import ColorSwitcher from "../elements/switcher/ColorSwitcher";
import Domain from "../component/dedicated/domain/index";

const CreativeAgency = () => {
  return (
    <>
      <SEO title="Web Development & Cybersecurity Company India | Odhav Technologies LLP" />
      <ColorSwitcher />
      <main className="main-wrapper">
        <HeaderTwo />
        <BannerTwo />
        <div className="section section-padding">
          <div className="container">
            <SectionTitle
              subtitle="What We Can Do For You"
              title="Services we can <br> help you with"
              description=""
              textAlignment="heading-left mb--20 mb_md--70"
              textColor=""
            />
            <div className="row">
              <ServicePropOne
                colSize="col-lg-4"
                serviceStyle="service-style-2"
                itemShow="3"
                marginTop="yes"
              />
            </div>
          </div>
          <ul className="shape-group-7 list-unstyled">
            <li className="shape shape-1">
              <img
                src={process.env.PUBLIC_URL + "/images/others/circle-2.png"}
                alt="circle"
              />
            </li>
            <li className="shape shape-2">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-2.png"}
                alt="Line"
              />
            </li>
            <li className="shape shape-3">
              <img
                src={process.env.PUBLIC_URL + "/images/others/bubble-1.png"}
                alt="Line"
              />
            </li>
          </ul>
        </div>
        {/* Application Security Services Section */}
        <div className="section section-padding bg-color-light">
          <div className="container">
            <div className="row align-items-center">
              <div className="col-lg-6">
                <SectionTitle
                  subtitle="🔒 Cybersecurity & VAPT"
                  title="Application Security Services"
                  description="We provide VAPT assessments for web and mobile applications, helping businesses meet security compliance requirements from auditors and enterprise clients."
                  textAlignment="heading-left mb--20"
                  textColor=""
                />
                <Link to={process.env.PUBLIC_URL + "/cybersecurity-vapt-services"} className="axil-btn btn-fill-primary btn-large">
                  Learn More
                </Link>
              </div>
              <div className="col-lg-6">
                <div className="row" style={{marginTop: '20px'}}>
                  <div className="col-sm-6" style={{marginBottom: '20px'}}>
                    <div style={{padding: '25px', background: '#fff', borderRadius: '12px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', borderLeft: '4px solid var(--color-primary)'}}>
                      <h4 style={{marginBottom: '8px', color: 'var(--color-primary)'}}>50+</h4>
                      <p style={{marginBottom: 0, fontSize: '14px'}}>VAPT Assessments Completed</p>
                    </div>
                  </div>
                  <div className="col-sm-6" style={{marginBottom: '20px'}}>
                    <div style={{padding: '25px', background: '#fff', borderRadius: '12px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', borderLeft: '4px solid var(--color-primary)'}}>
                      <h4 style={{marginBottom: '8px', color: 'var(--color-primary)'}}>500+</h4>
                      <p style={{marginBottom: 0, fontSize: '14px'}}>Vulnerabilities Remediated</p>
                    </div>
                  </div>
                  <div className="col-sm-6" style={{marginBottom: '20px'}}>
                    <div style={{padding: '25px', background: '#fff', borderRadius: '12px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', borderLeft: '4px solid var(--color-primary)'}}>
                      <h4 style={{marginBottom: '8px', color: 'var(--color-primary)'}}>OWASP</h4>
                      <p style={{marginBottom: 0, fontSize: '14px'}}>Certified Methodology</p>
                    </div>
                  </div>
                  <div className="col-sm-6" style={{marginBottom: '20px'}}>
                    <div style={{padding: '25px', background: '#fff', borderRadius: '12px', boxShadow: '0 5px 20px rgba(0,0,0,0.05)', borderLeft: '4px solid var(--color-primary)'}}>
                      <h4 style={{marginBottom: '8px', color: 'var(--color-primary)'}}>100%</h4>
                      <p style={{marginBottom: 0, fontSize: '14px'}}>Client Satisfaction</p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <Domain />
        <ProjectOne parentClass="bg-color-light" />
        <CounterUpOne />
        {/* <TestimonialOne /> */}
        <div className="section section-padding">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 1927.432 377.655"
          >
            <g
              id="Group_1306"
              data-name="Group 1306"
              transform="translate(0 -2.345)"
            >
              <g
                id="Group_1305"
                data-name="Group 1305"
                transform="translate(89.768 -5087.134)"
                style={{
                  isolation: "isolate",
                }}
              >
                <path
                  id="Path_455"
                  data-name="Path 455"
                  d="M68.691,74.415,45.794,0,0,52.472Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 56.463, 5149.557)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_459"
                  data-name="Path 459"
                  d="M10.494,0,.954,19.081,0,1.908Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 424.059, 5332.672)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_460"
                  data-name="Path 460"
                  d="M13.833,4.77,9.54,19.558,0,0Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 864.315, 5214.438)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_461"
                  data-name="Path 461"
                  d="M15.265,7.632,0,0,8.586,20.035Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 320.103, 5239.557)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_464"
                  data-name="Path 464"
                  d="M33.868,31.483,16.7,0,0,56.288Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 26.936, 5407.448)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_465"
                  data-name="Path 465"
                  d="M13.834,2.862,10.494,13.357,0,0Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 44.798, 5342.669)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_466"
                  data-name="Path 466"
                  d="M46.748,21.943,30.529,0,0,25.282Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 894.876, 5422.376)"
                  fill="#2aa4dd"
                />
                <path
                  id="Path_467"
                  data-name="Path 467"
                  d="M8.109,10.494,6.678,0,0,13.834Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 817.048, 5329.283)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_468"
                  data-name="Path 468"
                  d="M22.749,0,17.215,26.437,0,27.667Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 757.741, 5364.353)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_469"
                  data-name="Path 469"
                  d="M37.207,0,33.391,60.581,0,22.9Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1215.364, 5285.203)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_470"
                  data-name="Path 470"
                  d="M73.938,67.26,0,32.437,57.719,0Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1020.968, 5239.266)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_471"
                  data-name="Path 471"
                  d="M32.994,29.235,7.1,0,0,35.918Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 521.968, 5413.783)"
                  fill="#2aa4dd"
                />
                <path
                  id="Path_472"
                  data-name="Path 472"
                  d="M24.8,7.155,0,0,8.109,37.685Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1118.402, 5413.826)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_473"
                  data-name="Path 473"
                  d="M32.32,0,26.26,79.4,0,33.047Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1637.428, 5329.403)"
                  fill="#2aa4dd"
                />
                <path
                  id="Path_474"
                  data-name="Path 474"
                  d="M4.218,0,28.47,16.344,0,50.087Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1270.566, 5336.524)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_475"
                  data-name="Path 475"
                  d="M14.311,11.925,22.9,0,0,2.385Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1037.864, 5310.901)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_476"
                  data-name="Path 476"
                  d="M9.54,4.293,6.2,18.6,0,0Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 603.292, 5169.579)"
                  fill="#2aa4dd"
                />
                <path
                  id="Path_477"
                  data-name="Path 477"
                  d="M8.586,5.247.954,0,0,20.035Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1396.8, 5366.593)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_478"
                  data-name="Path 478"
                  d="M50.087,20.512,0,0,42.455,75.369Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 1653.097, 5430.594)"
                  fill="#d3d3d3"
                />
                <path
                  id="Path_479"
                  data-name="Path 479"
                  d="M17.173,0,0,3.339,11.448,20.512Z"
                  transform="matrix(0.485, -0.875, 0.875, 0.485, 646.708, 5362.285)"
                  fill="#d3d3d3"
                />
              </g>
              <path
                id="Path_11604"
                data-name="Path 11604"
                d="M-3388,3168.24h684.687l199.913-67.249,175.826,67.249,206.783-51.709,212.946-15.54,209.12,47.75,238.117,19.5"
                transform="translate(3388 -2975)"
                fill="none"
                stroke="#707070"
                strokeWidth={1}
              />
              <g
                id="Mobile-app-development"
                transform="translate(36.793 -316.388)"
              >
                <g
                  id="Group_1304"
                  data-name="Group 1304"
                  transform="translate(216.029 372)"
                >
                  <g id="phone" transform="translate(65.409)">
                    <g id="Group-14">
                      <rect
                        id="Rectangle"
                        width={3.806}
                        height={30.697}
                        rx={1.903}
                        transform="translate(127.025 54.731)"
                        fill="#3e6c98"
                      />
                      <rect
                        id="Rectangle-Copy-3"
                        width={3.806}
                        height={17.847}
                        rx={1.903}
                        transform="translate(0 47.116)"
                        fill="#3e6c98"
                      />
                      <rect
                        id="Rectangle-Copy-4"
                        width={3.806}
                        height={17.847}
                        rx={1.903}
                        transform="translate(0 24.51)"
                        fill="#3e6c98"
                      />
                      <rect
                        id="Rectangle-2"
                        data-name="Rectangle"
                        width={126.312}
                        height={239.628}
                        rx={29.808}
                        transform="translate(1.427)"
                        fill="#d3d3d3"
                      />
                      <ellipse
                        id="Oval"
                        cx={2.26}
                        cy={2.261}
                        rx={2.26}
                        ry={2.261}
                        transform="translate(62.323 5.473)"
                        fill="#3e6c98"
                      />
                      <rect
                        id="Rectangle-3"
                        data-name="Rectangle"
                        width={16.413}
                        height={3.331}
                        rx={1.666}
                        transform="translate(56.376 12.374)"
                        fill="#3e6c98"
                      />
                      <ellipse
                        id="Oval-2"
                        data-name="Oval"
                        cx={8.445}
                        cy={8.448}
                        rx={8.445}
                        ry={8.448}
                        transform="translate(55.187 216.783)"
                        fill="#3e6c98"
                      />
                      <ellipse
                        id="Oval-Copy-6"
                        cx={4.282}
                        cy={4.283}
                        rx={4.282}
                        ry={4.283}
                        transform="translate(59.469 221.066)"
                        fill="none"
                        stroke="#91adc8"
                        strokeWidth={0.864}
                      />
                      <g
                        id="Combined-Shape"
                        transform="translate(7.988 20.602)"
                      >
                        <rect
                          id="Rectangle_604"
                          data-name="Rectangle 604"
                          width={113.429}
                          height={190.094}
                          rx={10.8}
                          transform="translate(0 0)"
                          fill="none"
                          stroke="rgba(4,4,4,0.62)"
                          strokeWidth={0.5}
                        />
                        <g
                          id="Group_1303"
                          data-name="Group 1303"
                          transform="translate(114.305 190.655) rotate(180)"
                          opacity={0.151}
                        >
                          <rect
                            id="Rectangle_605"
                            data-name="Rectangle 605"
                            width={114.305}
                            height={74.092}
                            rx={9.072}
                            transform="translate(0 0)"
                          />
                          <rect
                            id="Rectangle_606"
                            data-name="Rectangle 606"
                            width={114.305}
                            height={74.092}
                            rx={9.072}
                            transform="translate(0 0)"
                            fill="#fff"
                          />
                        </g>
                      </g>
                    </g>
                    <g
                      id="Group-56"
                      transform="translate(154.243 75.193) rotate(180)"
                    >
                      <g id="Rectangle-4" data-name="Rectangle">
                        <rect
                          id="Rectangle_607"
                          data-name="Rectangle 607"
                          width={131.382}
                          height={41.04}
                          rx={9.072}
                        />
                        <rect
                          id="Rectangle_608"
                          data-name="Rectangle 608"
                          width={131.382}
                          height={41.04}
                          rx={9.072}
                          fill="#fff"
                        />
                      </g>
                      <g
                        id="_129817"
                        data-name={129817}
                        transform="translate(122.274 32.777) rotate(-180)"
                      >
                        <path
                          id="XMLID_503_"
                          d="M15.852,9.536a.826.826,0,0,0,0-1.169l-1.24-1.24a.826.826,0,0,0-1.049-.1L10.956,8.8l1.761-2.625a.826.826,0,0,0-.1-1.045L9.926,2.44a.826.826,0,0,0-.943-.16L8.518,2.5l.223-.494a.826.826,0,0,0-.169-.924L7.727.242a.826.826,0,0,0-1.169,0L0,6.8l9.294,9.294Z"
                          transform="translate(8.413 0)"
                          fill="#aac4f3"
                        />
                        <path
                          id="XMLID_1199_"
                          d="M7.192,0l-1.9,1.9a.826.826,0,0,0,0,1.169l1.8,1.8a1.61,1.61,0,0,1-.275,2.5C1.528,10.738,1.035,11.232.873,11.394a2.984,2.984,0,0,0,4.22,4.22c.162-.162.656-.656,4.029-5.947a1.612,1.612,0,0,1,2.5-.275l1.8,1.8a.826.826,0,0,0,1.169,0l1.9-1.9ZM3.859,14.279a1.168,1.168,0,1,1,0-1.652A1.168,1.168,0,0,1,3.859,14.279Z"
                          transform="translate(0 8.022)"
                          fill="#aac4f3"
                        />
                      </g>
                      <line
                        id="Path-623"
                        x2={77.129}
                        transform="translate(14.968 26.366)"
                        fill="none"
                        stroke="#aac4f3"
                        strokeLinecap="round"
                        strokeWidth={3.024}
                      />
                      <line
                        id="Path-623-Copy"
                        x2={55.594}
                        transform="translate(36.587 19.208)"
                        fill="none"
                        stroke="#aac4f3"
                        strokeLinecap="round"
                        strokeWidth={3.024}
                      />
                      <line
                        id="Path-623-Copy-2"
                        x2={69.053}
                        transform="translate(23.045 12.049)"
                        fill="none"
                        stroke="#aac4f3"
                        strokeLinecap="round"
                        strokeWidth={3.024}
                      />
                    </g>
                    <g
                      id="Group-57"
                      transform="translate(154.243 128.632) rotate(180)"
                    >
                      <g
                        id="Combined-Shape-2"
                        data-name="Combined-Shape"
                        transform="translate(0 0)"
                      >
                        <rect
                          id="Rectangle_609"
                          data-name="Rectangle 609"
                          width={131.382}
                          height={41.044}
                          rx={9.072}
                          transform="translate(0 0)"
                        />
                        <rect
                          id="Rectangle_610"
                          data-name="Rectangle 610"
                          width={131.382}
                          height={41.044}
                          rx={9.072}
                          transform="translate(0 0)"
                          fill="#fff"
                        />
                      </g>
                      <line
                        id="Path-623-2"
                        data-name="Path-623"
                        x2={77.129}
                        transform="translate(14.968 27.8)"
                        fill="none"
                        stroke="#9bcbdc"
                        strokeLinecap="round"
                        strokeWidth={3.024}
                      />
                      <line
                        id="Path-623-Copy-2-2"
                        data-name="Path-623-Copy"
                        x2={55.594}
                        transform="translate(36.587 20.642)"
                        fill="none"
                        stroke="#9bcbdc"
                        strokeLinecap="round"
                        strokeWidth={3.024}
                      />
                      <line
                        id="Path-623-Copy-2-3"
                        data-name="Path-623-Copy-2"
                        x2={69.053}
                        transform="translate(23.045 13.483)"
                        fill="none"
                        stroke="#9bcbdc"
                        strokeLinecap="round"
                        strokeWidth={3.024}
                      />
                      <g
                        id="_70367"
                        data-name={70367}
                        transform="translate(100.809 9.389)"
                      >
                        <path
                          id="Shape"
                          d="M22.22,12.383a.726.726,0,0,1-.716.549,2.461,2.461,0,0,0-1.685,4.283.619.619,0,0,1,.068.84,11.029,11.029,0,0,1-1.766,1.783.62.62,0,0,1-.847-.068,2.569,2.569,0,0,0-2.78-.624,2.476,2.476,0,0,0-1.505,2.42.618.618,0,0,1-.547.651,11.127,11.127,0,0,1-2.507.007.62.62,0,0,1-.552-.638,2.48,2.48,0,0,0-1.526-2.378,2.576,2.576,0,0,0-2.759.628.622.622,0,0,1-.841.071,11.07,11.07,0,0,1-1.8-1.783.62.62,0,0,1,.067-.847A2.47,2.47,0,0,0,3.143,14.5,2.577,2.577,0,0,0,.718,12.989a.606.606,0,0,1-.644-.547,11.165,11.165,0,0,1,0-2.535A.737.737,0,0,1,.8,9.359,2.444,2.444,0,0,0,3.094,7.832a2.478,2.478,0,0,0-.623-2.756.619.619,0,0,1-.068-.84A11.069,11.069,0,0,1,4.166,2.452a.62.62,0,0,1,.848.067,2.565,2.565,0,0,0,2.778.625A2.472,2.472,0,0,0,9.3.726.619.619,0,0,1,9.848.074,11.093,11.093,0,0,1,12.355.068a.62.62,0,0,1,.552.638,2.477,2.477,0,0,0,1.525,2.377,2.572,2.572,0,0,0,2.76-.628.623.623,0,0,1,.841-.07,11.1,11.1,0,0,1,1.8,1.783.619.619,0,0,1-.067.847,2.47,2.47,0,0,0-.624,2.78,2.5,2.5,0,0,0,2.28,1.511l.138,0a.62.62,0,0,1,.652.546A11.156,11.156,0,0,1,22.22,12.383ZM11.163,7.4a3.718,3.718,0,1,0,3.718,3.718A3.722,3.722,0,0,0,11.163,7.4Z"
                          transform="translate(0 0)"
                          fill="#9bcbdc"
                        />
                      </g>
                    </g>
                  </g>
                  <g id="flower-copy" transform="translate(0 163.883)">
                    <path
                      id="Path-88"
                      d="M55.831,10.8Q44.987,28.43,47.136,60.666"
                      transform="translate(-21.011 -4.851)"
                      fill="none"
                      stroke="#000"
                      strokeWidth={0.5}
                      fillRule="evenodd"
                    />
                    <path
                      id="Path-89"
                      d="M64.673,23.5q-15.1-12.383-17.247,41.246"
                      transform="translate(-21.301 -9.513)"
                      fill="none"
                      stroke="#000"
                      strokeWidth={0.5}
                      fillRule="evenodd"
                    />
                    <path
                      id="Path-90"
                      d="M22.556,12.772Q43.634-1.84,36.6,59.715"
                      transform="translate(-10.131 -4.477)"
                      fill="none"
                      stroke="#000"
                      strokeWidth={0.5}
                      fillRule="evenodd"
                    />
                    <path
                      id="Path-91"
                      d="M25.034,47.851q14.687-5.521,12.935,27.91"
                      transform="translate(-11.244 -21.14)"
                      fill="none"
                      stroke="#000"
                      strokeWidth={0.5}
                      fillRule="evenodd"
                    />
                    <path
                      id="Path-92"
                      d="M47.253,24.777q7.142,15.67,1.094,40.086"
                      transform="translate(-21.223 -11.128)"
                      fill="none"
                      stroke="#000"
                      strokeWidth={0.5}
                      fillRule="evenodd"
                    />
                    <g
                      id="Path-115-_-Path-116-_-Path-117-_-Path-118-_-Path-119-_-Path-120-_-Path-121-Mask"
                      data-name="Path-115-+-Path-116-+-Path-117-+-Path-118-+-Path-119-+-Path-120-+-Path-121-Mask"
                      transform="translate(0 3.565)"
                    >
                      <path
                        id="Mask"
                        d="M12.326,4.735c-.447-.62-.066-1.14.737-1.251S14.982.75,11.242.114s-4.362,1.6-5.158,1.6A6.034,6.034,0,0,0,2,5.383c-1.011,2.933.51,6.349-.446,7.958-.489.822-4.06,7.747,1.638,5.93s5.8-2.3,7.64-1.809,8.4-1.244,10.523-5.73.941-8.2-1.988-8.573-4.191.082-4.977.847S12.774,5.355,12.326,4.735Z"
                        transform="translate(0 0)"
                        fill="#009c58"
                      />
                      <path
                        id="Path-115"
                        d="M12.781,8.818Q3.722,16.243.793,23.086"
                        transform="translate(-0.356 -3.96)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-116"
                        d="M12.559,17.766q1.964,3.448.371,8.036"
                        transform="translate(-5.64 -7.979)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-117"
                        d="M7.191,20.164Q4.647,19.312,3.445,21.2"
                        transform="translate(-1.547 -8.938)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-118"
                        d="M18.829,12.071q4.107,4.207,2.053,10.774"
                        transform="translate(-8.457 -5.421)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-119"
                        d="M9.92,14.16A7.784,7.784,0,0,0,3,14.16"
                        transform="translate(-1.347 -5.995)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-120"
                        d="M21.123,10.068q7.009,1.8,9.44,6.717"
                        transform="translate(-9.487 -4.522)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-121"
                        d="M15.819,7.172q-.685-3.443-5.574-3.978"
                        transform="translate(-4.601 -1.435)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                    <g id="Path-87" transform="translate(7.419 53.735)">
                      <path
                        id="Mask-2"
                        data-name="Mask"
                        d="M.106.178H33.2l-6.944,20.1H7.281Z"
                        transform="translate(2.921 1.902)"
                        fill="#ffcf57"
                      />
                      <path
                        id="Path_11576"
                        data-name="Path 11576"
                        d="M22.785-.593Q8.913.179,9.336,8.215c.423,8.036,12.566,4.331,14.673,10.931q2.107,6.6-24.392,2.722L-5.389-3.6l26.964.885Z"
                        transform="translate(5.389 3.597)"
                        fill="#db9601"
                        fillRule="evenodd"
                        opacity={0.379}
                      />
                      <path
                        id="Path-129"
                        d="M-4.013,2.586A82.323,82.323,0,0,0,35,1.856"
                        transform="translate(4.771 1.148)"
                        fill="none"
                        stroke="#fff"
                        strokeWidth={0.6}
                        fillRule="evenodd"
                      />
                    </g>
                    <ellipse
                      id="Oval-3"
                      data-name="Oval"
                      cx={16.549}
                      cy={1.964}
                      rx={16.549}
                      ry={1.964}
                      transform="translate(10.446 53.735)"
                      fill="#a17101"
                    />
                    <ellipse
                      id="Oval-4"
                      data-name="Oval"
                      cx={14.119}
                      cy={1.502}
                      rx={14.119}
                      ry={1.502}
                      transform="translate(12.992 53.735)"
                      fill="#2e1e00"
                    />
                    <g
                      id="Path-95-_-Path-96-_-Path-97-_-Path-98-_-Path-99-_-Path-100-Mask"
                      data-name="Path-95-+-Path-96-+-Path-97-+-Path-98-+-Path-99-+-Path-100-Mask"
                      transform="translate(17.119 8.717)"
                    >
                      <path
                        id="Mask-3"
                        data-name="Mask"
                        d="M9.364,3.581c.1.816,0,1.421-.933,1.376S7.2,3.545,7.567,2.411,6.3-.664,2.941.657s-4.706,8.015.7,12.5,5.4,8.568,6.221,8.568.745-4.116,4.934-7.693,3.5-10.4.179-12.851S8.928.72,8.791,1.609,9.26,2.766,9.364,3.581Z"
                        transform="translate(0 0)"
                        fill="#7cc08f"
                      />
                      <path
                        id="Path-95"
                        d="M15.779,8.953a67.5,67.5,0,0,1,1.167,16.791"
                        transform="translate(-7.087 -4.021)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-96"
                        d="M15.018,20.175q-1.9,1.009-2.97,5.09"
                        transform="translate(-5.411 -9.061)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-97"
                        d="M16.971,15.8q3.733.533,6.126,4.626"
                        transform="translate(-7.622 -7.094)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-98"
                        d="M11,11.673q-4.9.051-6.56,5.593"
                        transform="translate(-1.994 -5.243)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-99"
                        d="M16.066,8.292q4.58-2.735,8.37-.711"
                        transform="translate(-7.216 -3.018)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-100"
                        d="M9.2,10.091Q3.624,7.027.774,12.534"
                        transform="translate(-0.347 -4.04)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                    <g
                      id="Path-108-_-Path-109-_-Path-110-_-Path-111-_-Path-112-_-Path-113-_-Path-114-Mask"
                      data-name="Path-108-+-Path-109-+-Path-110-+-Path-111-+-Path-112-+-Path-113-+-Path-114-Mask"
                      transform="translate(37.851 9.834)"
                    >
                      <path
                        id="Mask-4"
                        data-name="Mask"
                        d="M4.77,3.392Q0,2.071,0,8.289c0,6.218,8.652,8.037,11.011,9.94s1.842,4.359,3.353,3.794,4.98-11.338,0-14.781Q12.925.418,8.919.036T4.77,3.392Z"
                        transform="translate(0 0)"
                        fill="#009c58"
                      />
                      <path
                        id="Path-108"
                        d="M8.534,6.119q9.754,7,9.257,18.734"
                        transform="translate(-3.833 -2.748)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-109"
                        d="M19.745,17.285A8.743,8.743,0,0,1,25.821,20.5"
                        transform="translate(-8.868 -7.763)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-110"
                        d="M17.545,15.26q-1.784,2.35,1.036,9.823"
                        transform="translate(-7.57 -6.854)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-111"
                        d="M12.226,11q-4.6,3.295-1.186,9.913"
                        transform="translate(-4.305 -4.942)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-112"
                        d="M16.118,11.806q2.184-2.134,5.453,0"
                        transform="translate(-7.239 -4.823)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-113"
                        d="M7.5,7.822Q2.21,9.484,3.848,16.652"
                        transform="translate(-1.554 -3.513)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-114"
                        d="M12.323,5.782Q12.3,1.295,17.14,2.049"
                        transform="translate(-5.535 -0.871)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                    <g
                      id="Path-101-_-Path-102-_-Path-103-_-Path-104-_-Path-105-_-Path-106-_-Path-107-Mask"
                      data-name="Path-101-+-Path-102-+-Path-103-+-Path-104-+-Path-105-+-Path-106-+-Path-107-Mask"
                      transform="translate(6.226 22.402)"
                    >
                      <path
                        id="Mask-5"
                        data-name="Mask"
                        d="M7.447,2.571C8.39,1.662,7.457-.66,4.343.18S-.617,4.272.189,8.561A5.643,5.643,0,0,0,.984,10.61c.483.659-.209,2.9.195,4.442s2.057,3.207,3.371,1.895a6.988,6.988,0,0,1,4.783-2.359c2.059-.108,6.445-3.347,5.715-7.316s-4.3-5.907-5.418-5.109-.418,2-1.272,2.2A1.034,1.034,0,0,1,7.447,2.571Z"
                        transform="translate(0)"
                        fill="#009c58"
                      />
                      <path
                        id="Path-101"
                        d="M9.819,7.822A17.258,17.258,0,0,0,5.047,20.7"
                        transform="translate(-2.255 -3.513)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-102"
                        d="M8.23,15.813a8.015,8.015,0,0,1,1.853,6.78"
                        transform="translate(-3.696 -7.102)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-103"
                        d="M4.689,18.646a2.584,2.584,0,0,0-2.524.837"
                        transform="translate(-0.973 -8.366)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-104"
                        d="M11.253,10.923q5.494,2.348,4.2,8.289"
                        transform="translate(-5.054 -4.906)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-105"
                        d="M13.187,8.591q6.2.99,7.864,4.527"
                        transform="translate(-5.923 -3.859)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-106"
                        d="M5.409,12.164Q2.276,10.313,0,12.028"
                        transform="translate(0 -5.032)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-107"
                        d="M8.026,6.777A4.691,4.691,0,0,0,2.6,3.679"
                        transform="translate(-1.17 -1.623)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                    <g
                      id="Path-122-_-Path-123-_-Path-124-_-Path-125-_-Path-126-_-Path-127-_-Path-128-Mask"
                      data-name="Path-122-+-Path-123-+-Path-124-+-Path-125-+-Path-126-+-Path-127-+-Path-128-Mask"
                      transform="translate(28.275 0)"
                    >
                      <path
                        id="Mask-6"
                        data-name="Mask"
                        d="M3.427,7.515C4.592,6.828,5.7,5.818,6.19,6.374S5.483,7.539,5.93,8.31s5.919,2.027,8.158.407,3.646-5.35,2.317-5.87-1.229-.52-1.329-1.13S13.059-.3,10.605.056,7.993,1.436,5.771,1.564-.1,2.847,0,5.3A2.308,2.308,0,0,0,3.427,7.515Z"
                        transform="translate(0 0)"
                        fill="#7cc08f"
                      />
                      <path
                        id="Path-122"
                        d="M10.947,6.374q3.742-5.087,6.7-6.049"
                        transform="translate(-4.917 -0.146)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-123"
                        d="M15.358,4.87A10.344,10.344,0,0,0,22,3.471"
                        transform="translate(-6.898 -1.559)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-124"
                        d="M14.82,3.917A1.647,1.647,0,0,1,14.5,1.588"
                        transform="translate(-6.36 -0.713)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-125"
                        d="M12.384,9.122q7.528,1.62,9.978-.494"
                        transform="translate(-5.562 -3.875)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-126"
                        d="M11.372,10.8q5.031,3.422,8.833,1.85"
                        transform="translate(-5.108 -4.851)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-127"
                        d="M11.453,6.064Q9.247,4.672,9.522,2.919"
                        transform="translate(-4.263 -1.311)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-128"
                        d="M6.881,8.784Q.995,9.357,1.4,6.31"
                        transform="translate(-0.616 -2.834)"
                        fill="none"
                        stroke="#000"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                  </g>
                  <g
                    id="hammer"
                    transform="matrix(-0.995, -0.105, 0.105, -0.995, 171.298, 212.414)"
                  >
                    <path
                      id="Rectangle-5"
                      data-name="Rectangle"
                      d="M0,28.921H4.132V2.066A2.066,2.066,0,0,0,0,2.066V28.921Z"
                      transform="matrix(0.588, 0.809, -0.809, 0.588, 29.265, 0)"
                      fillRule="evenodd"
                    />
                    <path
                      id="Path-547"
                      d="M13.211,15.279Q9.4,13.95,8.565,12.775a1.558,1.558,0,0,1,.08-1.866,1.928,1.928,0,0,0-.05-2.144L2.9.671A1.579,1.579,0,0,0,.7.288L.648.323a1.646,1.646,0,0,0-.339,2.27A11.822,11.822,0,0,1,1.953,5.482a4.074,4.074,0,0,1-.388,3.233l2.571,3.76a9.5,9.5,0,0,0,3.379,1.962A29.118,29.118,0,0,0,13.211,15.279Z"
                      transform="translate(0 10.369)"
                      fill="#dc5f58"
                      fillRule="evenodd"
                    />
                  </g>
                  <g id="Boys" transform="translate(54.804 141.499)">
                    <g
                      id="pants"
                      transform="translate(73.68 100.006) rotate(180)"
                    >
                      <g id="foot-left" transform="translate(52.995 0.518)">
                        <g id="Path-163" transform="translate(0 0)">
                          <path
                            id="Mask-7"
                            data-name="Mask"
                            d="M.843,17.836,5.61,7.549,4.45,6.569q.51-2.731.168-2.731C4.276,3.838-.219,3.29.008,0H7.221q2.907.281,2.726,5.944t-.223,13.4a30.6,30.6,0,0,1-5.156-.209A17.771,17.771,0,0,1,.843,17.836Z"
                            transform="translate(5.484 1.446)"
                            fill="#2a3756"
                          />
                          <path
                            id="Path_11577"
                            data-name="Path 11577"
                            d="M14.3,21.391V4.585q.252-3.14-9.684-2.247T6.146,0L17.489,1.446l-.3,20.567Z"
                            fill="#fff"
                            fillRule="evenodd"
                          />
                        </g>
                        <g id="Path-162" transform="translate(1.366 6.768)">
                          <path
                            id="Mask-8"
                            data-name="Mask"
                            d="M5.652,5.04q1.933-.675,2.917-3.793T10.879,2.81l-5.918,9.7L0,11.677.822,4.626Z"
                            transform="translate(0 0)"
                            fill="#ffd3c8"
                          />
                          <path
                            id="Path_11578"
                            data-name="Path 11578"
                            d="M0,10.449,2.715,0,4.3,10.075Z"
                            transform="translate(0.476 3.961)"
                            fill="#f1b2a2"
                            fillRule="evenodd"
                          />
                        </g>
                      </g>
                      <g id="Path-582" transform="translate(20.541 7.908)">
                        <path
                          id="Mask-9"
                          data-name="Mask"
                          d="M28.812,48.58Q35.95,33.162,15.307,12.424l19.348.012,1.3-9.518Q3.752-3.694.523,4.679T14,40.312Z"
                          transform="translate(1.429 0)"
                          fill="#824a4a"
                        />
                        <path
                          id="Path_11579"
                          data-name="Path 11579"
                          d="M0,0,26.868,22.454l-5.3-18.387Z"
                          transform="translate(26.868 32.462) rotate(180)"
                          fill="#774141"
                          fillRule="evenodd"
                        />
                      </g>
                      <g id="foot-right" transform="translate(6.018 0)">
                        <g id="Path-164" transform="translate(0)">
                          <path
                            id="Mask-10"
                            data-name="Mask"
                            d="M9.584,5.95Q3.068,6.413.928,3.98C-1.211,1.546.584,0,3.891,0H22.476q.589,7.644-1.367,9.525c-1.233,1.185-4.465-.176-10.228-3.357A3.255,3.255,0,0,0,9.584,5.95Z"
                            transform="translate(4.245 1.907)"
                            fill="#2a3756"
                          />
                          <path
                            id="Path_11580"
                            data-name="Path 11580"
                            d="M28.2,2.918H0L4.245,0H29.6Z"
                            fill="#fff"
                            fillRule="evenodd"
                          />
                        </g>
                        <g id="Path-161" transform="translate(13.829 7.076)">
                          <path
                            id="Mask-11"
                            data-name="Mask"
                            d="M2.786,6.139Q4.4,4.039,3.863,3.51A10.151,10.151,0,0,0,0,.781,1.125,1.125,0,0,1,1.415.054q.049.016.1.036L11.524,4.356h0A47.34,47.34,0,0,1,7.985,10.64Q6.186,13.276,2.786,6.139Z"
                            transform="translate(0 0)"
                            fill="#ffd3c8"
                          />
                          <path
                            id="Path_11581"
                            data-name="Path 11581"
                            d="M0,0,9.717,2.135,5.2,5.522Z"
                            transform="translate(2.782 5.118)"
                            fill="#f1b2a2"
                            fillRule="evenodd"
                          />
                        </g>
                      </g>
                      <path
                        id="Path-141"
                        d="M50.782,45.24q-40.411-6.734-48.473-12.5C-5.754,26.967,8.877,11.48,21.906,0l8.3,6L17.076,23.584q21.159-.491,29,4.549T50.782,45.24Z"
                        transform="translate(0 11.248)"
                        fill="#955454"
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-156"
                        d="M34.288,32.391Q32.093,19.921,0,20.5L11.025,5.531,4.1,0"
                        transform="translate(17.076 14.329)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-157"
                        d="M9.321,10.175Q2.636,1.453,0,0"
                        transform="translate(35.613 18.946)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-158"
                        d="M.639,4.7A5.483,5.483,0,0,0,0,0"
                        transform="translate(36.835 15.565)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <line
                        id="Path-160"
                        y1={8.354}
                        x2={1.256}
                        transform="translate(54.209 11.912)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                      />
                      <path
                        id="Path-145"
                        d="M5.986.2Q2.2-.48,0,1.129"
                        transform="translate(11.09 34.628)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-146"
                        d="M4.456,2.43Q3.3,0,0,0"
                        transform="translate(12.79 32.198)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-147"
                        d="M34.234,38.212Q40.192,26.72,8.959,24.889q-13.383-.6-6.774-7.631T18.121,0"
                        transform="translate(5.124 15.935)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                    <g id="head" transform="translate(53.022 0)">
                      <path
                        id="Path-541"
                        d="M21.246,8.5q3.32,1.166,3.9-3.34C25.675,1.12,20.034.573,15.5.069c-3.284-.365-4.87.73-4.87,2.753Q8.164,2.36,7.242,4.264t-.529,9.723L17.5,12.149Z"
                        transform="translate(-2.962 0)"
                        fill="#4c2603"
                        fillRule="evenodd"
                      />
                      <ellipse
                        id="Oval-5"
                        data-name="Oval"
                        cx={1.644}
                        cy={1.647}
                        rx={1.644}
                        ry={1.647}
                        transform="translate(16.245 9.67)"
                        fill="none"
                        stroke="#061537"
                        strokeLinecap="round"
                        strokeWidth={0.5}
                      />
                      <g id="Path-557" transform="translate(0 7.608)">
                        <path
                          id="Mask-12"
                          data-name="Mask"
                          d="M18.772.44a14.6,14.6,0,0,1-1.353,3.53l-.47,2.714a.275.275,0,0,1-.318.224L16.6,6.9l-.97-.281Q12.005,12.3,8.948,8.933l-2.9,4.5L0,9.323,3.721,5.1q2.168,1.883,6.586-1.131Q8.538,1.85,9.589.779t2.428.38q-.723,1.517-.193,1.319c.529-.2,1.5-2.038,2.252-2.038S15.631,1.85,17.607,0Z"
                          transform="translate(0 0)"
                          fill="#ffd3c8"
                        />
                        <path
                          id="Path_11582"
                          data-name="Path 11582"
                          d="M14.555,14.5a6.441,6.441,0,0,1-.254-2.443q-1.965,1.343-1.9,2.763t2.158.728Z"
                          transform="translate(-5.567 -5.413)"
                          fill="#f1b2a2"
                          fillRule="evenodd"
                        />
                      </g>
                      <line
                        id="Path-542"
                        x1={7.528}
                        y1={3.85}
                        transform="translate(11.856 8.048)"
                        fill="none"
                        stroke="#061537"
                        strokeLinecap="round"
                        strokeWidth={0.5}
                      />
                    </g>
                    <g id="hand" transform="translate(83.548 51.782)">
                      <path
                        id="Path-549"
                        d="M.1,0A7.093,7.093,0,0,0,3.856.617q-.524,2-2.377,1.478T.1,0Z"
                        transform="translate(10.364 4.04) rotate(-9)"
                        fill="#f1b2a2"
                        fillRule="evenodd"
                      />
                      <g id="Path-556" transform="translate(0 0)">
                        <path
                          id="Mask-13"
                          data-name="Mask"
                          d="M2.27,0Q9.133,2.516,9.747,3.466c.614.95,5.773,8.757,4.318,8.258q-1.454-.5-3.154-3.13.5,4.425-.332,5.449-1.255.113-.929-3.607L8.9,8.413q.186,4.135-.749,5.092-1.544.178-.611-2.922L7.114,8.531A2.927,2.927,0,0,1,5.675,11.27c-1.523,1-1.25-1.1,0-2.031L5.07,7.913A3.971,3.971,0,0,1,2.3,6.034,7.152,7.152,0,0,0,.086,3.308Q-.441,3.115,2.27,0Z"
                          transform="translate(0.598 2.24) rotate(-9)"
                          fill="#ffd3c8"
                        />
                        <path
                          id="Path_11583"
                          data-name="Path 11583"
                          d="M2.089,2.736V10.6L-1,8.269Z"
                          transform="translate(1 -1.297)"
                          fill="#f1b2a2"
                          fillRule="evenodd"
                        />
                      </g>
                    </g>
                    <g id="body" transform="translate(0 12.844)">
                      <path
                        id="Path-554"
                        d="M59.183,1.434l.605-.187a4.132,4.132,0,0,1,3.093.264L67.3,3.755a2.754,2.754,0,0,1,1.5,2.269L68.95,8.3h0Z"
                        transform="translate(-6.542 0.134)"
                        fill="#fff"
                        fillRule="evenodd"
                      />
                      <g id="Path-553" transform="translate(0 0)">
                        <path
                          id="Mask-14"
                          data-name="Mask"
                          d="M32.409.672C40.447,3.237,47.435,7.82,48.477,13.707q5.875,18.974,7,20.587t11.767,4.448l-2.026,6.7L51.56,41.555a4.682,4.682,0,0,1-2.812-2.23L40.533,24.54h0L31.144,35.845q-11.5,2.21-30.651-2.369A72.46,72.46,0,0,1,6.366,22.288q2.331-3.351,6.47-8.582Q24.372-1.893,32.409.672Z"
                          transform="translate(19.818 0.472)"
                          fill="#659cff"
                        />
                        <path
                          id="Path_11584"
                          data-name="Path 11584"
                          d="M39.23,33.573Q17.464,52.206,3.558,48.961l18.406,9.048L40.22,47.483l1.689-8Z"
                          transform="translate(18.441 -14.468)"
                          fill="#4c7fff"
                          fillRule="evenodd"
                        />
                        <rect
                          id="Rectangle-6"
                          data-name="Rectangle"
                          width={2.479}
                          height={8.263}
                          transform="translate(84.978 37.794) rotate(17)"
                          fill="#fff"
                        />
                        <path
                          id="Path-78"
                          d="M2.445,6.192a54.977,54.977,0,0,0-7.194,8.2q-2.031,3.116-21.494,1.335l-5.313-8.541L-36.377.9l1.818-2.006q14.425,13.19,16.5,13.19T2.445,6.192Z"
                          transform="translate(36.377 1.109)"
                          fill="#4c7fff"
                          fillRule="evenodd"
                        />
                      </g>
                      <path
                        id="Path-546"
                        d="M68.9,38.348l2.218,1.038-2.8-5.813"
                        transform="translate(-10.643 -14.468)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-552"
                        d="M102.937,53.023l2.026-6.7Q93.593,43.085,92.975,41.7T87.8,26.465q-2.13-8.342-3.324-9.266"
                        transform="translate(-17.903 -7.114)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                      <line
                        id="Path-555"
                        x1={9.321}
                        y2={11.241}
                        transform="translate(51.152 24.918)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                      />
                      <path
                        id="Path-383"
                        d="M96.2,64.086q-.244-.6,1.236-1.994a2.725,2.725,0,0,0-3.007,1.994"
                        transform="translate(-22.371 -27.266)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                  </g>
                  <g
                    id="stairs"
                    transform="translate(306.138 239.13) rotate(180)"
                  >
                    <path
                      id="Path-234"
                      d="M0,0,33.3,109.147a16.693,16.693,0,0,0,17.852,11.715,11.516,11.516,0,0,0,9.7-14.839L28.133,0h0"
                      transform="translate(0)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                      fillRule="evenodd"
                    />
                    <path
                      id="Path-626"
                      d="M0,80.691A14.485,14.485,0,0,0,11.927,70.051L30.411,0h0"
                      transform="translate(25.826)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                      fillRule="evenodd"
                    />
                    <path
                      id="Path-626-Copy"
                      d="M0,80.691A14.485,14.485,0,0,0,11.927,70.051L30.411,0h0"
                      transform="translate(53.719)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                      fillRule="evenodd"
                    />
                    <line
                      id="Path-627"
                      x2={27.257}
                      transform="translate(4.589 14.654)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                    />
                    <line
                      id="Path-627-Copy-4"
                      x2={27.257}
                      transform="translate(54.31 8.594)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                    />
                    <line
                      id="Path-627-Copy-5"
                      x2={27.257}
                      transform="translate(48.246 29.802)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                    />
                    <line
                      id="Path-627-Copy-6"
                      x2={27.257}
                      transform="translate(42.789 51.011)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                    />
                    <line
                      id="Path-627-Copy"
                      x2={27.257}
                      transform="translate(11.259 36.468)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                    />
                    <line
                      id="Path-627-Copy-2"
                      x2={27.257}
                      transform="translate(18.535 58.282)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                    />
                    <line
                      id="Path-627-Copy-3"
                      x2={27.257}
                      transform="translate(25.205 80.703)"
                      fill="none"
                      stroke="#607385"
                      strokeLinecap="round"
                      strokeWidth={4}
                    />
                  </g>
                  <g id="women" transform="translate(217.449 46.353)">
                    <g id="foot" transform="translate(42.928 118.564)">
                      <g id="left-foot" transform="translate(0 0)">
                        <g id="Path-517" transform="translate(3.183)">
                          <path
                            id="Mask-15"
                            data-name="Mask"
                            d="M6.863,1.222Q8.929,6.356,8.419,6.76c-.51.4-8.557,3.088-8.417,4.8q.14,1.716,15.87-4.381L13.2.318Z"
                            transform="translate(0 0.959)"
                            fill="#ffd3c8"
                          />
                          <path
                            id="Path_11589"
                            data-name="Path 11589"
                            d="M12.426,1.848h8.6L19.809-2Z"
                            transform="translate(-5.581 2)"
                            fill="#f1b2a2"
                            fillRule="evenodd"
                          />
                        </g>
                        <path
                          id="Path-508"
                          d="M1.521,19.5c3.526.246,16.356-3.776,17.324-4.96q.968-1.184-.357-4.348-.266,1.575-5.034,2.925c-2.215.627-5.882.206-7.557.68C1.076,15.164-2.005,19.257,1.521,19.5Z"
                          transform="translate(0 -3.477)"
                          fill="#230d99"
                          fillRule="evenodd"
                        />
                      </g>
                      <g id="right-foot" transform="translate(17.636 16.18)">
                        <g id="Path-509" transform="translate(2.936 0)">
                          <path
                            id="Mask-16"
                            data-name="Mask"
                            d="M6.556.884Q9.443,12.619,8.933,13.022c-.51.4-9.071,3.361-8.931,5.078q.14,1.716,16.384-4.655L13.426,0Z"
                            transform="translate(0 0)"
                            fill="#ffd3c8"
                          />
                          <path
                            id="Path_11590"
                            data-name="Path 11590"
                            d="M11.248,7.056,22.522,9.67,20.973,5.224Z"
                            transform="translate(-5.052 -2.346)"
                            fill="#f1b2a2"
                            fillRule="evenodd"
                          />
                        </g>
                        <path
                          id="Path-508-Copy"
                          d="M1.788,30.78c3.38.16,15.464-3.823,17.324-4.96q1.86-1.136-.149-4.779a44.916,44.916,0,0,1-7.88,3.422c-4.055,1.312-6.374.959-8.488,2.435S-1.592,30.62,1.788,30.78Z"
                          transform="translate(0 -9.45)"
                          fill="#230d99"
                          fillRule="evenodd"
                        />
                      </g>
                    </g>
                    <g
                      id="head-2"
                      data-name="head"
                      transform="translate(32.919 9.768)"
                    >
                      <path
                        id="Path-507"
                        d="M2.426,6.391q-1.378-4.558,1.7-5.326C7.205.3,14.978-2.514,15.984,5.969q4.883.529,5.348,5.707,7.15,2.911,5.228,6.647T7.577,15.95Z"
                        transform="translate(-0.898)"
                        fill="#061537"
                        fillRule="evenodd"
                      />
                      <ellipse
                        id="Oval-Copy-29"
                        cx={1.573}
                        cy={1.586}
                        rx={1.573}
                        ry={1.586}
                        transform="translate(0 5.509)"
                        fill="none"
                        stroke="#324a83"
                        strokeLinecap="round"
                        strokeWidth={0.5}
                      />
                      <path
                        id="Path-506"
                        d="M8.666,18.182c-2.522-1.144-1.122-4.964.176-5.35s2.261-2.12-1.108-2.12Q4.366,10.712,2.881,6a9.161,9.161,0,0,0-.46,3.92q-1.266,2.472-.792,2.66a4.835,4.835,0,0,0,.792.252q.273,3.748,1.307,4.561C4.762,18.206,11.188,19.326,8.666,18.182Z"
                        transform="translate(-0.674 -2.695)"
                        fill="#ffd3c8"
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-505"
                        d="M0,12.88q8.572.449,9.365.889"
                        transform="translate(0 -5.785)"
                        fill="none"
                        stroke="#324a83"
                        strokeLinecap="round"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                    <g
                      id="pants-2"
                      data-name="pants"
                      transform="translate(30.368 59.277)"
                    >
                      <path
                        id="Mask-17"
                        data-name="Mask"
                        d="M31.869,0q7.076,7.618,3.538,19.639-.162,24.328.7,32.9t2.766,23.451l-9.785.77q-4-19.8-5.091-29.517-.706-6.271-3.741-26.5l-1.432.565L13.189,32.225a3.305,3.305,0,0,0-.215,2.512l7.284,23.057h0l-7.695,2.243L1.381,36.448a14.323,14.323,0,0,1-.718-10.44L8.858,0H31.869Z"
                        transform="translate(9.509 3.413)"
                        fill="#ff6f66"
                      />
                      <path
                        id="Path-497"
                        d="M41.065,17.593a56.111,56.111,0,0,1,1.428,9.464c.236,5.549-6.1,53.738-2.7,62.131q7.074,17.483,2.047-3.793L35.024,49.768,34.7,30.854l.32-1.9a10.88,10.88,0,0,0,4.771-4.176A11.839,11.839,0,0,0,41.065,17.593Z"
                        transform="translate(-6.077 -4.489)"
                        fill="#dc5f58"
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-6"
                        d="M15.978-1.223l-3.4.993A20.658,20.658,0,0,0-.678,11.626l-3.907,9.341A15.7,15.7,0,0,0-4.4,33.5L7.164,59.045h0L-8.712,48.431l-8.55-31.243L1.795-6.2Z"
                        transform="translate(17.262 6.195)"
                        fill="#dc5f58"
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-511"
                        d="M35.714,17.593q1.218,8.523-6.559,11.8Q23.381,40.22,23.166,41.151t3.8,12.558"
                        transform="translate(-0.891 -4.489)"
                        fill="none"
                        stroke="#301913"
                        strokeWidth={0.5}
                        fillRule="evenodd"
                      />
                    </g>
                    <g id="hand-2" data-name="hand" transform="translate(0 0)">
                      <path
                        id="Mask-18"
                        data-name="Mask"
                        d="M7.563,9.419,6.69,7.868a8.373,8.373,0,0,0,.615-3.452q-.836-.253-1.132.373Q3.725.292,2.837.112C1.95-.069-.488-.323.087,1.963A9.974,9.974,0,0,0,2.1,5.972q-.815,2.767.626,4.382a22.776,22.776,0,0,0,1.908,1.99Z"
                        transform="translate(0 0.195)"
                        fill="#ffd3c8"
                      />
                      <path
                        id="Path-514"
                        d="M3.061,10.842a4.614,4.614,0,0,0,1.285,4.1L8.478,13.45l-4.29,4.2-2.008-3.4a7.232,7.232,0,0,1,.113-2.339A1.9,1.9,0,0,1,3.061,10.842Z"
                        transform="translate(-0.964 -4.674)"
                        fill="#f1b2a2"
                        fillRule="evenodd"
                      />
                      <path
                        id="Path-50"
                        d="M11.17,7.3q.21,3.383.584,3.5t1.266-3.764l-1.694-.692Z"
                        transform="translate(-5.017 -2.654)"
                        fill="#f1b2a2"
                        fillRule="evenodd"
                      />
                      <line
                        id="Path-510"
                        x2={2.756}
                        y2={4.025}
                        transform="translate(1.923)"
                        fill="none"
                        stroke="#99776c"
                        strokeWidth={0.5}
                      />
                      <line
                        id="Path-515"
                        x2={2.873}
                        y2={4.09}
                        transform="translate(0.908 0.195)"
                        fill="none"
                        stroke="#99776c"
                        strokeWidth={0.5}
                      />
                      <line
                        id="Path-516"
                        x2={2.596}
                        y2={4.043}
                        transform="translate(0 0.626)"
                        fill="none"
                        stroke="#99776c"
                        strokeWidth={0.5}
                      />
                    </g>
                    <g
                      id="body-2"
                      data-name="body"
                      transform="translate(0.908 8.63)"
                    >
                      <g id="Path-513" transform="translate(0)">
                        <path
                          id="Mask-19"
                          data-name="Mask"
                          d="M.2,2.983Q9.819,16.4,15.683,19.1c5.864,2.7,13.759,4.582,16.269,9.387q-1.5,8.271,2.4,9.939c3.9,1.668,10.592,10.727,10.592,17.379q9.631-1.088,14.891,2.33c4.467,2.9,10.138,2.9,13.528-.569.072-.073-1.347-.642-2.892-1.761a11.333,11.333,0,0,1-1.738-1.745l-12.287-21.6,7.856,7.4-.48,5.575,4,7.026Q73.12,40.655,70.695,36c-2.425-4.654-13.571-17.329-18.03-17.742S38.5,16.5,33.227,15.772,15.47,11.8,4.442,0Z"
                          transform="translate(2.112)"
                          fill="#56d4b7"
                        />
                        <path
                          id="Path_11591"
                          data-name="Path 11591"
                          d="M-1.127,2.973q9.005,12.978,15.3,15.476c6.3,2.5,17.713,4.89,20.695,9.356,1.371,2.054-2.757,5.258.882,9.129,4.044,4.3,11.971,1.493,17.918,13.708,4.178,8.581,20.243,8.932,22.812,7.86,1.589-.663-3.829,7.6-8.644,7.659q-4,.048-15.845-6.257L33.21,55.022-4,5.778Z"
                          transform="translate(4 -1.335)"
                          fill="#4bc5a9"
                          fillRule="evenodd"
                        />
                        <path
                          id="Path-5"
                          d="M106.839,66.715l6.257,11.05,1.293.829L120,64.83q-8.359-11.022-6.908-9.188c1.451,1.834,1.293,6.261-2.178,6.261q-3.471,0-12.141-9.123l2.865,5.044Z"
                          transform="translate(-42.161 -23.705)"
                          fill="#4bc5a9"
                          fillRule="evenodd"
                        />
                      </g>
                      <path
                        id="Path-512"
                        d="M66.779,20.273q-3.235,1.074-1.838,5.536-2.514,1.781-1.168,4.319c1.346,2.538,7.616,3.328,9.662-.511q6.143,4.219,10.465-1.05-.916-3.773-5.8-4.1T66.779,20.273Z"
                        transform="translate(-26.228 -9.105)"
                        fill="#061537"
                        fillRule="evenodd"
                      />
                    </g>
                  </g>
                </g>
              </g>
              <g
                id="Path_11592"
                data-name="Path 11592"
                transform="translate(623.538 117.172)"
                fill="#fff"
              >
                <path
                  d="M 76.88796234130859 150.2759094238281 C 66.97909545898438 150.2759094238281 57.36850738525391 148.3360290527344 48.3231201171875 144.5101623535156 C 43.97534942626953 142.6712188720703 39.78164291381836 140.3948974609375 35.8585090637207 137.7444915771484 C 31.97173500061035 135.1186218261719 28.3166675567627 132.1029205322266 24.99484825134277 128.7810821533203 C 21.67300796508789 125.4592590332031 18.65730285644531 121.8041915893555 16.03143882751465 117.9174194335938 C 13.38103008270264 113.9942779541016 11.10471248626709 109.8005752563477 9.26575756072998 105.4528045654297 C 5.439894199371338 96.40741729736328 3.50000786781311 86.79682922363281 3.50000786781311 76.88796234130859 C 3.50000786781311 66.97909545898438 5.439894199371338 57.36850738525391 9.26575756072998 48.3231201171875 C 11.10471248626709 43.97534942626953 13.38103008270264 39.78164291381836 16.03143882751465 35.8585090637207 C 18.65730285644531 31.97173500061035 21.67300796508789 28.3166675567627 24.99484825134277 24.99484825134277 C 28.3166675567627 21.67300796508789 31.97173500061035 18.65730285644531 35.8585090637207 16.03143882751465 C 39.78164291381836 13.38103008270264 43.97534942626953 11.10471248626709 48.3231201171875 9.26575756072998 C 57.36850738525391 5.439894199371338 66.97909545898438 3.50000786781311 76.88796234130859 3.50000786781311 C 86.79682922363281 3.50000786781311 96.40741729736328 5.439894199371338 105.4528045654297 9.26575756072998 C 109.8005752563477 11.10471248626709 113.9942779541016 13.38103008270264 117.9174194335938 16.03143882751465 C 121.8041915893555 18.65730285644531 125.4592590332031 21.67300796508789 128.7810821533203 24.99484825134277 C 132.1029205322266 28.3166675567627 135.1186218261719 31.97173500061035 137.7444915771484 35.8585090637207 C 140.3948974609375 39.78164291381836 142.6712188720703 43.97534942626953 144.5101623535156 48.3231201171875 C 148.3360290527344 57.36850738525391 150.2759094238281 66.97909545898438 150.2759094238281 76.88796234130859 C 150.2759094238281 86.79682922363281 148.3360290527344 96.40741729736328 144.5101623535156 105.4528045654297 C 142.6712188720703 109.8005752563477 140.3948974609375 113.9942779541016 137.7444915771484 117.9174194335938 C 135.1186218261719 121.8041915893555 132.1029205322266 125.4592590332031 128.7810821533203 128.7810821533203 C 125.4592590332031 132.1029205322266 121.8041915893555 135.1186218261719 117.9174194335938 137.7444915771484 C 113.9942779541016 140.3948974609375 109.8005752563477 142.6712188720703 105.4528045654297 144.5101623535156 C 96.40741729736328 148.3360290527344 86.79682922363281 150.2759094238281 76.88796234130859 150.2759094238281 Z"
                  stroke="none"
                />
                <path
                  d="M 76.88796234130859 6.999984741210938 C 38.35159301757812 6.999984741210938 6.999984741210938 38.35159301757812 6.999984741210938 76.88796234130859 C 6.999984741210938 115.4243011474609 38.35159301757812 146.7759094238281 76.88796234130859 146.7759094238281 C 115.4243011474609 146.7759094238281 146.7759094238281 115.4243011474609 146.7759094238281 76.88796234130859 C 146.7759094238281 38.35159301757812 115.4243011474609 6.999984741210938 76.88796234130859 6.999984741210938 M 76.88796234130859 -1.52587890625e-05 C 119.3520202636719 -1.52587890625e-05 153.7759094238281 34.42391204833984 153.7759094238281 76.88796234130859 C 153.7759094238281 119.3520202636719 119.3520202636719 153.7759094238281 76.88796234130859 153.7759094238281 C 34.42391204833984 153.7759094238281 -1.52587890625e-05 119.3520202636719 -1.52587890625e-05 76.88796234130859 C -1.52587890625e-05 34.42391204833984 34.42391204833984 -1.52587890625e-05 76.88796234130859 -1.52587890625e-05 Z"
                  stroke="none"
                  fill="#b2b2b2"
                />
              </g>
              <g
                id="Path_11593"
                data-name="Path 11593"
                transform="translate(777.314 53.164)"
                fill="#fff"
              >
                <path
                  d="M 76.88796234130859 150.2759094238281 C 66.97909545898438 150.2759094238281 57.36850738525391 148.3360290527344 48.3231201171875 144.5101623535156 C 43.97534942626953 142.6712188720703 39.78164291381836 140.3948974609375 35.8585090637207 137.7444915771484 C 31.97173500061035 135.1186218261719 28.3166675567627 132.1029205322266 24.99484825134277 128.7810821533203 C 21.67300796508789 125.4592590332031 18.65730285644531 121.8041915893555 16.03143882751465 117.9174194335938 C 13.38103008270264 113.9942779541016 11.10471248626709 109.8005752563477 9.26575756072998 105.4528045654297 C 5.439894199371338 96.40741729736328 3.50000786781311 86.79682922363281 3.50000786781311 76.88796234130859 C 3.50000786781311 66.97909545898438 5.439894199371338 57.36850738525391 9.26575756072998 48.3231201171875 C 11.10471248626709 43.97534942626953 13.38103008270264 39.78164291381836 16.03143882751465 35.8585090637207 C 18.65730285644531 31.97173500061035 21.67300796508789 28.3166675567627 24.99484825134277 24.99484825134277 C 28.3166675567627 21.67300796508789 31.97173500061035 18.65730285644531 35.8585090637207 16.03143882751465 C 39.78164291381836 13.38103008270264 43.97534942626953 11.10471248626709 48.3231201171875 9.26575756072998 C 57.36850738525391 5.439894199371338 66.97909545898438 3.50000786781311 76.88796234130859 3.50000786781311 C 86.79682922363281 3.50000786781311 96.40741729736328 5.439894199371338 105.4528045654297 9.26575756072998 C 109.8005752563477 11.10471248626709 113.9942779541016 13.38103008270264 117.9174194335938 16.03143882751465 C 121.8041915893555 18.65730285644531 125.4592590332031 21.67300796508789 128.7810821533203 24.99484825134277 C 132.1029205322266 28.3166675567627 135.1186218261719 31.97173500061035 137.7444915771484 35.8585090637207 C 140.3948974609375 39.78164291381836 142.6712188720703 43.97534942626953 144.5101623535156 48.3231201171875 C 148.3360290527344 57.36850738525391 150.2759094238281 66.97909545898438 150.2759094238281 76.88796234130859 C 150.2759094238281 86.79682922363281 148.3360290527344 96.40741729736328 144.5101623535156 105.4528045654297 C 142.6712188720703 109.8005752563477 140.3948974609375 113.9942779541016 137.7444915771484 117.9174194335938 C 135.1186218261719 121.8041915893555 132.1029205322266 125.4592590332031 128.7810821533203 128.7810821533203 C 125.4592590332031 132.1029205322266 121.8041915893555 135.1186218261719 117.9174194335938 137.7444915771484 C 113.9942779541016 140.3948974609375 109.8005752563477 142.6712188720703 105.4528045654297 144.5101623535156 C 96.40741729736328 148.3360290527344 86.79682922363281 150.2759094238281 76.88796234130859 150.2759094238281 Z"
                  stroke="none"
                />
                <path
                  d="M 76.88796234130859 6.999984741210938 C 38.35159301757812 6.999984741210938 6.999984741210938 38.35159301757812 6.999984741210938 76.88796234130859 C 6.999984741210938 115.4243011474609 38.35159301757812 146.7759094238281 76.88796234130859 146.7759094238281 C 115.4243011474609 146.7759094238281 146.7759094238281 115.4243011474609 146.7759094238281 76.88796234130859 C 146.7759094238281 38.35159301757812 115.4243011474609 6.999984741210938 76.88796234130859 6.999984741210938 M 76.88796234130859 -1.52587890625e-05 C 119.3520202636719 -1.52587890625e-05 153.7759094238281 34.42391204833984 153.7759094238281 76.88796234130859 C 153.7759094238281 119.3520202636719 119.3520202636719 153.7759094238281 76.88796234130859 153.7759094238281 C 34.42391204833984 153.7759094238281 -1.52587890625e-05 119.3520202636719 -1.52587890625e-05 76.88796234130859 C -1.52587890625e-05 34.42391204833984 34.42391204833984 -1.52587890625e-05 76.88796234130859 -1.52587890625e-05 Z"
                  stroke="none"
                  fill="#b2b2b2"
                />
              </g>
              <g
                id="Path_11594"
                data-name="Path 11594"
                transform="translate(938.193 97)"
                fill="#fff"
              >
                <path
                  d="M 76.88796234130859 150.2759094238281 C 66.97909545898438 150.2759094238281 57.36850738525391 148.3360290527344 48.3231201171875 144.5101623535156 C 43.97534942626953 142.6712188720703 39.78164291381836 140.3948974609375 35.8585090637207 137.7444915771484 C 31.97173500061035 135.1186218261719 28.3166675567627 132.1029205322266 24.99484825134277 128.7810821533203 C 21.67300796508789 125.4592590332031 18.65730285644531 121.8041915893555 16.03143882751465 117.9174194335938 C 13.38103008270264 113.9942779541016 11.10471248626709 109.8005752563477 9.26575756072998 105.4528045654297 C 5.439894199371338 96.40741729736328 3.50000786781311 86.79682922363281 3.50000786781311 76.88796234130859 C 3.50000786781311 66.97909545898438 5.439894199371338 57.36850738525391 9.26575756072998 48.3231201171875 C 11.10471248626709 43.97534942626953 13.38103008270264 39.78164291381836 16.03143882751465 35.8585090637207 C 18.65730285644531 31.97173500061035 21.67300796508789 28.3166675567627 24.99484825134277 24.99484825134277 C 28.3166675567627 21.67300796508789 31.97173500061035 18.65730285644531 35.8585090637207 16.03143882751465 C 39.78164291381836 13.38103008270264 43.97534942626953 11.10471248626709 48.3231201171875 9.26575756072998 C 57.36850738525391 5.439894199371338 66.97909545898438 3.50000786781311 76.88796234130859 3.50000786781311 C 86.79682922363281 3.50000786781311 96.40741729736328 5.439894199371338 105.4528045654297 9.26575756072998 C 109.8005752563477 11.10471248626709 113.9942779541016 13.38103008270264 117.9174194335938 16.03143882751465 C 121.8041915893555 18.65730285644531 125.4592590332031 21.67300796508789 128.7810821533203 24.99484825134277 C 132.1029205322266 28.3166675567627 135.1186218261719 31.97173500061035 137.7444915771484 35.8585090637207 C 140.3948974609375 39.78164291381836 142.6712188720703 43.97534942626953 144.5101623535156 48.3231201171875 C 148.3360290527344 57.36850738525391 150.2759094238281 66.97909545898438 150.2759094238281 76.88796234130859 C 150.2759094238281 86.79682922363281 148.3360290527344 96.40741729736328 144.5101623535156 105.4528045654297 C 142.6712188720703 109.8005752563477 140.3948974609375 113.9942779541016 137.7444915771484 117.9174194335938 C 135.1186218261719 121.8041915893555 132.1029205322266 125.4592590332031 128.7810821533203 128.7810821533203 C 125.4592590332031 132.1029205322266 121.8041915893555 135.1186218261719 117.9174194335938 137.7444915771484 C 113.9942779541016 140.3948974609375 109.8005752563477 142.6712188720703 105.4528045654297 144.5101623535156 C 96.40741729736328 148.3360290527344 86.79682922363281 150.2759094238281 76.88796234130859 150.2759094238281 Z"
                  stroke="none"
                />
                <path
                  d="M 76.88796234130859 6.999984741210938 C 38.35159301757812 6.999984741210938 6.999984741210938 38.35159301757812 6.999984741210938 76.88796234130859 C 6.999984741210938 115.4243011474609 38.35159301757812 146.7759094238281 76.88796234130859 146.7759094238281 C 115.4243011474609 146.7759094238281 146.7759094238281 115.4243011474609 146.7759094238281 76.88796234130859 C 146.7759094238281 38.35159301757812 115.4243011474609 6.999984741210938 76.88796234130859 6.999984741210938 M 76.88796234130859 -1.52587890625e-05 C 119.3520202636719 -1.52587890625e-05 153.7759094238281 34.42391204833984 153.7759094238281 76.88796234130859 C 153.7759094238281 119.3520202636719 119.3520202636719 153.7759094238281 76.88796234130859 153.7759094238281 C 34.42391204833984 153.7759094238281 -1.52587890625e-05 119.3520202636719 -1.52587890625e-05 76.88796234130859 C -1.52587890625e-05 34.42391204833984 34.42391204833984 -1.52587890625e-05 76.88796234130859 -1.52587890625e-05 Z"
                  stroke="none"
                  fill="#b2b2b2"
                />
              </g>
              <g
                id="Path_11595"
                data-name="Path 11595"
                transform="translate(1108.878 76.452)"
                fill="#fff"
              >
                <path
                  d="M 83.163818359375 162.8276214599609 C 77.75643920898438 162.8276214599609 72.35350799560547 162.2830810546875 67.10507965087891 161.2090759277344 C 61.99181747436523 160.1627655029297 56.96227264404297 158.6015014648438 52.15615081787109 156.5686950683594 C 47.43648529052734 154.5724334716797 42.88410568237305 152.1014556884766 38.62546157836914 149.2243957519531 C 34.40639114379883 146.3740081787109 30.43881797790527 143.1004638671875 26.83300971984863 139.4946441650391 C 23.22717475891113 135.8888244628906 19.95362854003906 131.9212646484375 17.103271484375 127.7021789550781 C 14.22617530822754 123.4435348510742 11.75519943237305 118.8911514282227 9.75896167755127 114.1715087890625 C 7.726128101348877 109.365364074707 6.164865970611572 104.3358154296875 5.118556499481201 99.22255706787109 C 4.044556617736816 93.97412872314453 3.500008821487427 88.57119750976562 3.500008821487427 83.163818359375 C 3.500008821487427 77.75643920898438 4.044556617736816 72.35350799560547 5.118556499481201 67.10507965087891 C 6.164865970611572 61.99181747436523 7.726128101348877 56.96227264404297 9.75896167755127 52.15615081787109 C 11.75519943237305 47.43648529052734 14.22617530822754 42.88410568237305 17.103271484375 38.62546157836914 C 19.95362854003906 34.40639114379883 23.22717475891113 30.43881797790527 26.83300971984863 26.83300971984863 C 30.43881797790527 23.22717475891113 34.40639114379883 19.95362854003906 38.62546157836914 17.103271484375 C 42.88410568237305 14.22617530822754 47.43648529052734 11.75519943237305 52.15615081787109 9.75896167755127 C 56.96227264404297 7.726128101348877 61.99181747436523 6.164865970611572 67.10507965087891 5.118556499481201 C 72.35350799560547 4.044556617736816 77.75643920898438 3.500008821487427 83.163818359375 3.500008821487427 C 88.57119750976562 3.500008821487427 93.97412872314453 4.044556617736816 99.22255706787109 5.118556499481201 C 104.3358154296875 6.164865970611572 109.365364074707 7.726128101348877 114.1715087890625 9.75896167755127 C 118.8911514282227 11.75519943237305 123.4435348510742 14.22617530822754 127.7021789550781 17.103271484375 C 131.9212646484375 19.95362854003906 135.8888244628906 23.22717475891113 139.4946441650391 26.83300971984863 C 143.1004638671875 30.43881797790527 146.3740081787109 34.40639114379883 149.2243957519531 38.62546157836914 C 152.1014556884766 42.88410568237305 154.5724334716797 47.43648529052734 156.5686950683594 52.15615081787109 C 158.6015014648438 56.96227264404297 160.1627655029297 61.99181747436523 161.2090759277344 67.10507965087891 C 162.2830810546875 72.35350799560547 162.8276214599609 77.75643920898438 162.8276214599609 83.163818359375 C 162.8276214599609 88.57119750976562 162.2830810546875 93.97412872314453 161.2090759277344 99.22255706787109 C 160.1627655029297 104.3358154296875 158.6015014648438 109.365364074707 156.5686950683594 114.1715087890625 C 154.5724334716797 118.8911514282227 152.1014556884766 123.4435348510742 149.2243957519531 127.7021789550781 C 146.3740081787109 131.9212646484375 143.1004638671875 135.8888244628906 139.4946441650391 139.4946441650391 C 135.8888244628906 143.1004638671875 131.9212646484375 146.3740081787109 127.7021789550781 149.2243957519531 C 123.4435348510742 152.1014556884766 118.8911514282227 154.5724334716797 114.1715087890625 156.5686950683594 C 109.365364074707 158.6015014648438 104.3358154296875 160.1627655029297 99.22255706787109 161.2090759277344 C 93.97412872314453 162.2830810546875 88.57119750976562 162.8276214599609 83.163818359375 162.8276214599609 Z"
                  stroke="none"
                />
                <path
                  d="M 83.163818359375 6.999984741210938 C 41.16693115234375 6.999984741210938 6.999984741210938 41.16693115234375 6.999984741210938 83.163818359375 C 6.999984741210938 125.1606750488281 41.16693115234375 159.3276214599609 83.163818359375 159.3276214599609 C 125.1606750488281 159.3276214599609 159.3276214599609 125.1606750488281 159.3276214599609 83.163818359375 C 159.3276214599609 41.16693115234375 125.1606750488281 6.999984741210938 83.163818359375 6.999984741210938 M 83.163818359375 -1.52587890625e-05 C 129.0939331054688 -1.52587890625e-05 166.3276214599609 37.23370361328125 166.3276214599609 83.163818359375 C 166.3276214599609 129.0939331054688 129.0939331054688 166.3276214599609 83.163818359375 166.3276214599609 C 37.23370361328125 166.3276214599609 -1.52587890625e-05 129.0939331054688 -1.52587890625e-05 83.163818359375 C -1.52587890625e-05 37.23370361328125 37.23370361328125 -1.52587890625e-05 83.163818359375 -1.52587890625e-05 Z"
                  stroke="none"
                  fill="#b2b2b2"
                />
              </g>
              <g
                id="Path_11596"
                data-name="Path 11596"
                transform="translate(1294.112 49.103)"
                fill="#fff"
              >
                <path
                  d="M 76.88796234130859 150.2759094238281 C 66.97909545898438 150.2759094238281 57.36850738525391 148.3360290527344 48.3231201171875 144.5101623535156 C 43.97534942626953 142.6712188720703 39.78164291381836 140.3948974609375 35.8585090637207 137.7444915771484 C 31.97173500061035 135.1186218261719 28.3166675567627 132.1029205322266 24.99484825134277 128.7810821533203 C 21.67300796508789 125.4592590332031 18.65730285644531 121.8041915893555 16.03143882751465 117.9174194335938 C 13.38103008270264 113.9942779541016 11.10471248626709 109.8005752563477 9.26575756072998 105.4528045654297 C 5.439894199371338 96.40741729736328 3.50000786781311 86.79682922363281 3.50000786781311 76.88796234130859 C 3.50000786781311 66.97909545898438 5.439894199371338 57.36850738525391 9.26575756072998 48.3231201171875 C 11.10471248626709 43.97534942626953 13.38103008270264 39.78164291381836 16.03143882751465 35.8585090637207 C 18.65730285644531 31.97173500061035 21.67300796508789 28.3166675567627 24.99484825134277 24.99484825134277 C 28.3166675567627 21.67300796508789 31.97173500061035 18.65730285644531 35.8585090637207 16.03143882751465 C 39.78164291381836 13.38103008270264 43.97534942626953 11.10471248626709 48.3231201171875 9.26575756072998 C 57.36850738525391 5.439894199371338 66.97909545898438 3.50000786781311 76.88796234130859 3.50000786781311 C 86.79682922363281 3.50000786781311 96.40741729736328 5.439894199371338 105.4528045654297 9.26575756072998 C 109.8005752563477 11.10471248626709 113.9942779541016 13.38103008270264 117.9174194335938 16.03143882751465 C 121.8041915893555 18.65730285644531 125.4592590332031 21.67300796508789 128.7810821533203 24.99484825134277 C 132.1029205322266 28.3166675567627 135.1186218261719 31.97173500061035 137.7444915771484 35.8585090637207 C 140.3948974609375 39.78164291381836 142.6712188720703 43.97534942626953 144.5101623535156 48.3231201171875 C 148.3360290527344 57.36850738525391 150.2759094238281 66.97909545898438 150.2759094238281 76.88796234130859 C 150.2759094238281 86.79682922363281 148.3360290527344 96.40741729736328 144.5101623535156 105.4528045654297 C 142.6712188720703 109.8005752563477 140.3948974609375 113.9942779541016 137.7444915771484 117.9174194335938 C 135.1186218261719 121.8041915893555 132.1029205322266 125.4592590332031 128.7810821533203 128.7810821533203 C 125.4592590332031 132.1029205322266 121.8041915893555 135.1186218261719 117.9174194335938 137.7444915771484 C 113.9942779541016 140.3948974609375 109.8005752563477 142.6712188720703 105.4528045654297 144.5101623535156 C 96.40741729736328 148.3360290527344 86.79682922363281 150.2759094238281 76.88796234130859 150.2759094238281 Z"
                  stroke="none"
                />
                <path
                  d="M 76.88796234130859 6.999984741210938 C 38.35159301757812 6.999984741210938 6.999984741210938 38.35159301757812 6.999984741210938 76.88796234130859 C 6.999984741210938 115.4243011474609 38.35159301757812 146.7759094238281 76.88796234130859 146.7759094238281 C 115.4243011474609 146.7759094238281 146.7759094238281 115.4243011474609 146.7759094238281 76.88796234130859 C 146.7759094238281 38.35159301757812 115.4243011474609 6.999984741210938 76.88796234130859 6.999984741210938 M 76.88796234130859 -1.52587890625e-05 C 119.3520202636719 -1.52587890625e-05 153.7759094238281 34.42391204833984 153.7759094238281 76.88796234130859 C 153.7759094238281 119.3520202636719 119.3520202636719 153.7759094238281 76.88796234130859 153.7759094238281 C 34.42391204833984 153.7759094238281 -1.52587890625e-05 119.3520202636719 -1.52587890625e-05 76.88796234130859 C -1.52587890625e-05 34.42391204833984 34.42391204833984 -1.52587890625e-05 76.88796234130859 -1.52587890625e-05 Z"
                  stroke="none"
                  fill="#b2b2b2"
                />
              </g>
              <g
                id="Path_11597"
                data-name="Path 11597"
                transform="translate(1472 67.843)"
                fill="#fff"
              >
                <path
                  d="M 76.88796234130859 150.2759094238281 C 66.97909545898438 150.2759094238281 57.36850738525391 148.3360290527344 48.3231201171875 144.5101623535156 C 43.97534942626953 142.6712188720703 39.78164291381836 140.3948974609375 35.8585090637207 137.7444915771484 C 31.97173500061035 135.1186218261719 28.3166675567627 132.1029205322266 24.99484825134277 128.7810821533203 C 21.67300796508789 125.4592590332031 18.65730285644531 121.8041915893555 16.03143882751465 117.9174194335938 C 13.38103008270264 113.9942779541016 11.10471248626709 109.8005752563477 9.26575756072998 105.4528045654297 C 5.439894199371338 96.40741729736328 3.50000786781311 86.79682922363281 3.50000786781311 76.88796234130859 C 3.50000786781311 66.97909545898438 5.439894199371338 57.36850738525391 9.26575756072998 48.3231201171875 C 11.10471248626709 43.97534942626953 13.38103008270264 39.78164291381836 16.03143882751465 35.8585090637207 C 18.65730285644531 31.97173500061035 21.67300796508789 28.3166675567627 24.99484825134277 24.99484825134277 C 28.3166675567627 21.67300796508789 31.97173500061035 18.65730285644531 35.8585090637207 16.03143882751465 C 39.78164291381836 13.38103008270264 43.97534942626953 11.10471248626709 48.3231201171875 9.26575756072998 C 57.36850738525391 5.439894199371338 66.97909545898438 3.50000786781311 76.88796234130859 3.50000786781311 C 86.79682922363281 3.50000786781311 96.40741729736328 5.439894199371338 105.4528045654297 9.26575756072998 C 109.8005752563477 11.10471248626709 113.9942779541016 13.38103008270264 117.9174194335938 16.03143882751465 C 121.8041915893555 18.65730285644531 125.4592590332031 21.67300796508789 128.7810821533203 24.99484825134277 C 132.1029205322266 28.3166675567627 135.1186218261719 31.97173500061035 137.7444915771484 35.8585090637207 C 140.3948974609375 39.78164291381836 142.6712188720703 43.97534942626953 144.5101623535156 48.3231201171875 C 148.3360290527344 57.36850738525391 150.2759094238281 66.97909545898438 150.2759094238281 76.88796234130859 C 150.2759094238281 86.79682922363281 148.3360290527344 96.40741729736328 144.5101623535156 105.4528045654297 C 142.6712188720703 109.8005752563477 140.3948974609375 113.9942779541016 137.7444915771484 117.9174194335938 C 135.1186218261719 121.8041915893555 132.1029205322266 125.4592590332031 128.7810821533203 128.7810821533203 C 125.4592590332031 132.1029205322266 121.8041915893555 135.1186218261719 117.9174194335938 137.7444915771484 C 113.9942779541016 140.3948974609375 109.8005752563477 142.6712188720703 105.4528045654297 144.5101623535156 C 96.40741729736328 148.3360290527344 86.79682922363281 150.2759094238281 76.88796234130859 150.2759094238281 Z"
                  stroke="none"
                />
                <path
                  d="M 76.88796234130859 6.999984741210938 C 38.35159301757812 6.999984741210938 6.999984741210938 38.35159301757812 6.999984741210938 76.88796234130859 C 6.999984741210938 115.4243011474609 38.35159301757812 146.7759094238281 76.88796234130859 146.7759094238281 C 115.4243011474609 146.7759094238281 146.7759094238281 115.4243011474609 146.7759094238281 76.88796234130859 C 146.7759094238281 38.35159301757812 115.4243011474609 6.999984741210938 76.88796234130859 6.999984741210938 M 76.88796234130859 -1.52587890625e-05 C 119.3520202636719 -1.52587890625e-05 153.7759094238281 34.42391204833984 153.7759094238281 76.88796234130859 C 153.7759094238281 119.3520202636719 119.3520202636719 153.7759094238281 76.88796234130859 153.7759094238281 C 34.42391204833984 153.7759094238281 -1.52587890625e-05 119.3520202636719 -1.52587890625e-05 76.88796234130859 C -1.52587890625e-05 34.42391204833984 34.42391204833984 -1.52587890625e-05 76.88796234130859 -1.52587890625e-05 Z"
                  stroke="none"
                  fill="#b2b2b2"
                />
              </g>
              <path
                id="Path_11598"
                data-name="Path 11598"
                d="M-56.02,0h5.08c2.8,0,5.12-1.16,5.12-3.84a2.961,2.961,0,0,0-2.24-3.04v-.08a3.089,3.089,0,0,0,1.64-2.8c0-2.56-2.2-3.24-4.92-3.24h-4.68Zm3.44-7.92v-2.44h1.16c1.12,0,1.64.32,1.64,1.12s-.52,1.32-1.64,1.32Zm0,5.28V-5.4h1.4c1.36,0,2,.36,2,1.32s-.64,1.44-2,1.44ZM-44.3,0h3.44V-4.36h1.32L-37.3,0h3.84l-2.82-5.04a3.988,3.988,0,0,0,2.1-3.76c0-3.24-2.4-4.2-5.2-4.2H-44.3Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72Zm11.8.76c.32-1.24.64-2.8.92-4.12h.08c.32,1.3.64,2.88.96,4.12l.22.9h-2.4Zm-5,6.32h3.52l.64-2.76h3.64L-25.62,0h3.64l-3.96-13H-30.1Zm12.8,0h3.44V-13h-3.44Zm5.8,0h3.28V-3.76a48.644,48.644,0,0,0-.44-4.96h.08c.4,1,.8,2.04,1.24,2.92L-8.42,0H-4.9V-13H-8.18v3.76a46.68,46.68,0,0,0,.44,4.96h-.08c-.4-1-.8-2.04-1.24-2.92L-11.94-13h-3.52ZM1.58.24c3.24,0,5.08-1.96,5.08-4.16A3.573,3.573,0,0,0,4.12-7.48L2.54-8.1C1.36-8.56.62-8.78.62-9.4c0-.58.52-.88,1.36-.88a4.655,4.655,0,0,1,2.52.92L6.3-11.6a6.433,6.433,0,0,0-4.32-1.64c-2.84,0-4.84,1.82-4.84,4.04A3.841,3.841,0,0,0-.24-5.58l1.62.68c1.1.44,1.76.64,1.76,1.26,0,.58-.44.92-1.48.92a5.249,5.249,0,0,1-3.2-1.16l-1.8,2.24A7.112,7.112,0,0,0,1.58.24ZM10.3,0h3.44V-10.12h3.44V-13H6.86v2.88H10.3ZM23.46.24c3.6,0,6.04-2.52,6.04-6.8,0-4.26-2.44-6.68-6.04-6.68s-6.04,2.4-6.04,6.68S19.86.24,23.46.24Zm0-2.96c-1.56,0-2.52-1.48-2.52-3.84s.96-3.72,2.52-3.72,2.52,1.36,2.52,3.72S25.02-2.72,23.46-2.72ZM31.3,0h3.44V-4.36h1.32L38.3,0h3.84L39.32-5.04a3.988,3.988,0,0,0,2.1-3.76c0-3.24-2.4-4.2-5.2-4.2H31.3Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72ZM43.38,0h3.08V-3.84c0-1.32-.28-3.72-.44-5.04h.08l1.04,3.52,1.6,4.3h1.84l1.6-4.3,1.08-3.52h.08c-.16,1.32-.44,3.72-.44,5.04V0h3.12V-13H52.34L50.46-7.68c-.24.72-.44,1.52-.68,2.28H49.7c-.24-.76-.44-1.56-.68-2.28L47.06-13H43.38ZM-24.14,25h3.44V12h-3.44Zm5.8,0h4.04c3.76,0,6.48-1.96,6.48-6.56S-10.54,12-14.5,12h-3.84Zm3.44-2.76V14.76h.2c1.88,0,3.36.64,3.36,3.68s-1.48,3.8-3.36,3.8ZM-6.02,25h8.6V22.12H-2.58V19.8H1.66V16.92H-2.58V14.88H2.38V12h-8.4ZM7.94,18.68c.32-1.24.64-2.8.92-4.12h.08c.32,1.3.64,2.88.96,4.12l.22.9H7.72ZM2.94,25H6.46l.64-2.76h3.64L11.38,25h3.64L11.06,12H6.9Zm16.92.24c3.24,0,5.08-1.96,5.08-4.16a3.573,3.573,0,0,0-2.54-3.56l-1.58-.62c-1.18-.46-1.92-.68-1.92-1.3,0-.58.52-.88,1.36-.88a4.655,4.655,0,0,1,2.52.92l1.8-2.24a6.433,6.433,0,0,0-4.32-1.64c-2.84,0-4.84,1.82-4.84,4.04a3.841,3.841,0,0,0,2.62,3.62l1.62.68c1.1.44,1.76.64,1.76,1.26,0,.58-.44.92-1.48.92a5.249,5.249,0,0,1-3.2-1.16l-1.8,2.24A7.112,7.112,0,0,0,19.86,25.24Z"
                transform="translate(700 194)"
                fill="#2aa4dd"
              />
              <path
                id="Path_11599"
                data-name="Path 11599"
                d="M-40.6,0h3.44V-4.12h1.4c2.72,0,5.2-1.38,5.2-4.56,0-3.28-2.44-4.32-5.28-4.32H-40.6Zm3.44-6.84v-3.44H-36c1.32,0,2.08.44,2.08,1.6s-.64,1.84-2,1.84ZM-28.96,0h8.36V-2.88h-4.92V-13h-3.44Zm13.24-6.32c.32-1.24.64-2.8.92-4.12h.08c.32,1.3.64,2.88.96,4.12l.22.9h-2.4Zm-5,6.32h3.52l.64-2.76h3.64L-12.28,0h3.64L-12.6-13h-4.16Zm12.8,0h3.28V-3.76a48.644,48.644,0,0,0-.44-4.96H-5c.4,1,.8,2.04,1.24,2.92L-.88,0H2.64V-13H-.64v3.76A46.68,46.68,0,0,0-.2-4.28H-.28c-.4-1-.8-2.04-1.24-2.92L-4.4-13H-7.92ZM10.96,0H14.4V-10.12h3.44V-13H7.52v2.88h3.44Zm8.28,0h3.44V-5.16h3.88V0H30V-13H26.56v4.84H22.68V-13H19.24ZM32.36,0h8.6V-2.88H35.8V-5.2h4.24V-8.08H35.8v-2.04h4.96V-13h-8.4ZM-37.86,25h3.44V20.88h1.4c2.72,0,5.2-1.38,5.2-4.56,0-3.28-2.44-4.32-5.28-4.32h-4.76Zm3.44-6.84V14.72h1.16c1.32,0,2.08.44,2.08,1.6s-.64,1.84-2,1.84Zm8.2,6.84h3.44V20.64h1.32L-19.22,25h3.84l-2.82-5.04a3.988,3.988,0,0,0,2.1-3.76c0-3.24-2.4-4.2-5.2-4.2h-4.92Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72Zm14.12,7.32c3.6,0,6.04-2.52,6.04-6.8,0-4.26-2.44-6.68-6.04-6.68s-6.04,2.4-6.04,6.68S-12.26,25.24-8.66,25.24Zm0-2.96c-1.56,0-2.52-1.48-2.52-3.84s.96-3.72,2.52-3.72,2.52,1.36,2.52,3.72S-7.1,22.28-8.66,22.28Zm9.6,2.96c3.16,0,4.64-2.2,4.64-4.88V12H2.14v8.08c0,1.72-.52,2.2-1.56,2.2a1.839,1.839,0,0,1-1.6-1.04l-2.16,1.48A4.187,4.187,0,0,0,.94,25.24ZM7.86,25h8.6V22.12H11.3V19.8h4.24V16.92H11.3V14.88h4.96V12H7.86Zm16.24.24a5.5,5.5,0,0,0,4.28-1.92l-1.8-2.04a3.153,3.153,0,0,1-2.36,1c-1.68,0-2.8-1.36-2.8-3.8,0-2.36,1.32-3.76,2.84-3.76a3.054,3.054,0,0,1,2.16.84l1.8-2.08a5.576,5.576,0,0,0-4.04-1.72c-3.28,0-6.28,2.48-6.28,6.84C17.9,23.04,20.78,25.24,24.1,25.24ZM31.94,25h3.44V14.88h3.44V12H28.5v2.88h3.44Z"
                transform="translate(853.776 123.992)"
                fill="#2aa4dd"
              />
              <path
                id="Path_11600"
                data-name="Path 11600"
                d="M-46.22.24c3.24,0,5.08-1.96,5.08-4.16a3.573,3.573,0,0,0-2.54-3.56l-1.58-.62c-1.18-.46-1.92-.68-1.92-1.3,0-.58.52-.88,1.36-.88a4.655,4.655,0,0,1,2.52.92l1.8-2.24a6.433,6.433,0,0,0-4.32-1.64c-2.84,0-4.84,1.82-4.84,4.04a3.841,3.841,0,0,0,2.62,3.62l1.62.68c1.1.44,1.76.64,1.76,1.26,0,.58-.44.92-1.48.92a5.249,5.249,0,0,1-3.2-1.16l-1.8,2.24A7.112,7.112,0,0,0-46.22.24ZM-37.5,0h3.44V-10.12h3.44V-13H-40.94v2.88h3.44Zm10.84-6.32c.32-1.24.64-2.8.92-4.12h.08c.32,1.3.64,2.88.96,4.12l.22.9h-2.4Zm-5,6.32h3.52l.64-2.76h3.64L-23.22,0h3.64l-3.96-13H-27.7Zm12.8,0h3.44V-4.36h1.32L-11.86,0h3.84l-2.82-5.04A3.988,3.988,0,0,0-8.74-8.8c0-3.24-2.4-4.2-5.2-4.2h-4.92Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72ZM-4.7,0h3.44V-10.12H2.18V-13H-8.14v2.88H-4.7ZM8.06,0h4.28l.96-5.16c.2-1,.34-2.08.48-3.04h.08c.12.96.28,2.04.48,3.04l1,5.16H19.7l2.2-13H18.62l-.76,5.68c-.14,1.32-.3,2.7-.44,4.08h-.08c-.24-1.38-.48-2.78-.72-4.08L15.42-13H12.54L11.26-7.32c-.24,1.34-.48,2.72-.72,4.08h-.08c-.14-1.36-.3-2.72-.44-4.08L9.34-13H5.82ZM23.02,0h3.44V-13H23.02ZM31.3,0h3.44V-10.12h3.44V-13H27.86v2.88H31.3Zm8.28,0h3.44V-5.16H46.9V0h3.44V-13H46.9v4.84H43.02V-13H39.58Zm-70.8,25h4.04c3.76,0,6.48-1.96,6.48-6.56S-23.42,12-27.38,12h-3.84Zm3.44-2.76V14.76h.2c1.88,0,3.36.64,3.36,3.68s-1.48,3.8-3.36,3.8ZM-18.9,25h8.6V22.12h-5.16V19.8h4.24V16.92h-4.24V14.88h4.96V12h-8.4Zm14.72.24C-.94,25.24.9,23.28.9,21.08a3.573,3.573,0,0,0-2.54-3.56l-1.58-.62c-1.18-.46-1.92-.68-1.92-1.3,0-.58.52-.88,1.36-.88a4.655,4.655,0,0,1,2.52.92L.54,13.4a6.433,6.433,0,0,0-4.32-1.64c-2.84,0-4.84,1.82-4.84,4.04A3.841,3.841,0,0,0-6,19.42l1.62.68c1.1.44,1.76.64,1.76,1.26,0,.58-.44.92-1.48.92a5.249,5.249,0,0,1-3.2-1.16l-1.8,2.24A7.112,7.112,0,0,0-4.18,25.24ZM2.46,25H5.9V12H2.46Zm11.8.24a6.567,6.567,0,0,0,4.4-1.6v-6.2H13.7v2.8h1.92v1.8a1.948,1.948,0,0,1-1,.24c-2.32,0-3.4-1.36-3.4-3.8,0-2.36,1.32-3.76,3.08-3.76a3.177,3.177,0,0,1,2.32.84l1.8-2.08a5.708,5.708,0,0,0-4.24-1.72c-3.48,0-6.48,2.48-6.48,6.84C7.7,23.04,10.62,25.24,14.26,25.24Zm6.4-.24h3.28V21.24a48.644,48.644,0,0,0-.44-4.96h.08c.4,1,.8,2.04,1.24,2.92L27.7,25h3.52V12H27.94v3.76a46.68,46.68,0,0,0,.44,4.96H28.3c-.4-1-.8-2.04-1.24-2.92L24.18,12H20.66Z"
                transform="translate(1015.081 168.94)"
                fill="#2aa4dd"
              />
              <path
                id="Path_11601"
                data-name="Path 11601"
                d="M-66,0h3.44V-4.12h1.4c2.72,0,5.2-1.38,5.2-4.56,0-3.28-2.44-4.32-5.28-4.32H-66Zm3.44-6.84v-3.44h1.16c1.32,0,2.08.44,2.08,1.6s-.64,1.84-2,1.84ZM-54.36,0h3.44V-4.36h1.32L-47.36,0h3.84l-2.82-5.04a3.988,3.988,0,0,0,2.1-3.76c0-3.24-2.4-4.2-5.2-4.2h-4.92Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72ZM-36.8.24c3.6,0,6.04-2.52,6.04-6.8,0-4.26-2.44-6.68-6.04-6.68s-6.04,2.4-6.04,6.68S-40.4.24-36.8.24Zm0-2.96c-1.56,0-2.52-1.48-2.52-3.84s.96-3.72,2.52-3.72,2.52,1.36,2.52,3.72S-35.24-2.72-36.8-2.72ZM-23.32.24a5.5,5.5,0,0,0,4.28-1.92l-1.8-2.04a3.153,3.153,0,0,1-2.36,1c-1.68,0-2.8-1.36-2.8-3.8,0-2.36,1.32-3.76,2.84-3.76A3.054,3.054,0,0,1-21-9.44l1.8-2.08a5.576,5.576,0,0,0-4.04-1.72c-3.28,0-6.28,2.48-6.28,6.84C-29.52-1.96-26.64.24-23.32.24ZM-17.76,0h8.6V-2.88h-5.16V-5.2h4.24V-8.08h-4.24v-2.04h4.96V-13h-8.4Zm10.6,0h8.6V-2.88H-3.72V-5.2H.52V-8.08H-3.72v-2.04H1.24V-13h-8.4ZM3.44,0H7.48c3.76,0,6.48-1.96,6.48-6.56S11.24-13,7.28-13H3.44ZM6.88-2.76v-7.48h.2c1.88,0,3.36.64,3.36,3.68s-1.48,3.8-3.36,3.8ZM20.24,0h4.28l.96-5.16c.2-1,.34-2.08.48-3.04h.08c.12.96.28,2.04.48,3.04l1,5.16h4.36l2.2-13H30.8l-.76,5.68c-.14,1.32-.3,2.7-.44,4.08h-.08c-.24-1.38-.48-2.78-.72-4.08L27.6-13H24.72L23.44-7.32c-.24,1.34-.48,2.72-.72,4.08h-.08c-.14-1.36-.3-2.72-.44-4.08L21.52-13H18ZM35.2,0h3.44V-13H35.2Zm8.28,0h3.44V-10.12h3.44V-13H40.04v2.88h3.44Zm8.28,0H55.2V-5.16h3.88V0h3.44V-13H59.08v4.84H55.2V-13H51.76ZM-62.8,25h4.04c3.76,0,6.48-1.96,6.48-6.56S-55,12-58.96,12H-62.8Zm3.44-2.76V14.76h.2c1.88,0,3.36.64,3.36,3.68s-1.48,3.8-3.36,3.8ZM-50.48,25h8.6V22.12h-5.16V19.8h4.24V16.92h-4.24V14.88h4.96V12h-8.4Zm12.72,0h4.16l3.92-13H-33.2l-1.4,5.68c-.34,1.38-.6,2.72-.96,4.12h-.08c-.36-1.4-.64-2.74-.96-4.12L-37.88,12h-3.64Zm8.8,0h8.6V22.12h-5.16V19.8h4.24V16.92h-4.24V14.88h4.96V12h-8.4Zm10.6,0H-10V22.12h-4.92V12h-3.44Zm14.76.24c3.6,0,6.04-2.52,6.04-6.8,0-4.26-2.44-6.68-6.04-6.68s-6.04,2.4-6.04,6.68S-7.2,25.24-3.6,25.24Zm0-2.96c-1.56,0-2.52-1.48-2.52-3.84s.96-3.72,2.52-3.72,2.52,1.36,2.52,3.72S-2.04,22.28-3.6,22.28ZM4.24,25H7.68V20.88h1.4c2.72,0,5.2-1.38,5.2-4.56C14.28,13.04,11.84,12,9,12H4.24Zm3.44-6.84V14.72H8.84c1.32,0,2.08.44,2.08,1.6s-.64,1.84-2,1.84ZM15.88,25h3.08V21.16c0-1.32-.28-3.72-.44-5.04h.08l1.04,3.52,1.6,4.3h1.84l1.6-4.3,1.08-3.52h.08c-.16,1.32-.44,3.72-.44,5.04V25h3.12V12H24.84l-1.88,5.32c-.24.72-.44,1.52-.68,2.28H22.2c-.24-.76-.44-1.56-.68-2.28L19.56,12H15.88Zm15,0h8.6V22.12H34.32V19.8h4.24V16.92H34.32V14.88h4.96V12h-8.4Zm10.6,0h3.28V21.24a48.644,48.644,0,0,0-.44-4.96h.08c.4,1,.8,2.04,1.24,2.92L48.52,25h3.52V12H48.76v3.76a46.68,46.68,0,0,0,.44,4.96h-.08c-.4-1-.8-2.04-1.24-2.92L45,12H41.48Zm15.4,0h3.44V14.88h3.44V12H53.44v2.88h3.44Z"
                transform="translate(1192.042 153.116)"
                fill="#2aa4dd"
              />
              <path
                id="Path_11602"
                data-name="Path 11602"
                d="M-47.5,0h3.44V-4.12h1.4c2.72,0,5.2-1.38,5.2-4.56,0-3.28-2.44-4.32-5.28-4.32H-47.5Zm3.44-6.84v-3.44h1.16c1.32,0,2.08.44,2.08,1.6s-.64,1.84-2,1.84ZM-35.86,0h8.36V-2.88h-4.92V-13h-3.44Zm13.24-6.32c.32-1.24.64-2.8.92-4.12h.08c.32,1.3.64,2.88.96,4.12l.22.9h-2.4Zm-5,6.32h3.52l.64-2.76h3.64L-19.18,0h3.64L-19.5-13h-4.16Zm12.8,0h3.28V-3.76a48.644,48.644,0,0,0-.44-4.96h.08c.4,1,.8,2.04,1.24,2.92L-7.78,0h3.52V-13H-7.54v3.76A46.68,46.68,0,0,0-7.1-4.28h-.08c-.4-1-.8-2.04-1.24-2.92L-11.3-13h-3.52ZM3.86,0H7.3V-4.48L11.22-13H7.62l-.96,2.72c-.34.98-.68,1.88-1.02,2.9H5.56c-.34-1.02-.66-1.92-.98-2.9L3.62-13H-.06L3.86-4.48ZM17.02.24c3.6,0,6.04-2.52,6.04-6.8,0-4.26-2.44-6.68-6.04-6.68s-6.04,2.4-6.04,6.68S13.42.24,17.02.24Zm0-2.96c-1.56,0-2.52-1.48-2.52-3.84s.96-3.72,2.52-3.72,2.52,1.36,2.52,3.72S18.58-2.72,17.02-2.72ZM30.18.24c3.64,0,5.32-2.08,5.32-6.52V-13H32.18v7.12c0,2.32-.64,3.16-2,3.16s-1.96-.84-1.96-3.16V-13H24.78v6.72C24.78-1.84,26.54.24,30.18.24ZM37.78,0h3.44V-4.36h1.32L44.78,0h3.84L45.8-5.04A3.988,3.988,0,0,0,47.9-8.8c0-3.24-2.4-4.2-5.2-4.2H37.78Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72ZM-50.2,25h3.08V21.16c0-1.32-.28-3.72-.44-5.04h.08l1.04,3.52,1.6,4.3H-43l1.6-4.3,1.08-3.52h.08c-.16,1.32-.44,3.72-.44,5.04V25h3.12V12h-3.68l-1.88,5.32c-.24.72-.44,1.52-.68,2.28h-.08c-.24-.76-.44-1.56-.68-2.28L-46.52,12H-50.2Zm18.36-6.32c.32-1.24.64-2.8.92-4.12h.08c.32,1.3.64,2.88.96,4.12l.22.9h-2.4Zm-5,6.32h3.52l.64-2.76h3.64L-28.4,25h3.64l-3.96-13h-4.16Zm12.8,0h3.44V20.64h1.32L-17.04,25h3.84l-2.82-5.04a3.988,3.988,0,0,0,2.1-3.76c0-3.24-2.4-4.2-5.2-4.2h-4.92Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72ZM-11.96,25h3.44V21.76L-7.28,20l2.88,5H-.64l-4.64-7.72L-1.4,12H-5.16l-3.28,4.84h-.08V12h-3.44ZM.08,25h8.6V22.12H3.52V19.8H7.76V16.92H3.52V14.88H8.48V12H.08Zm13.08,0H16.6V14.88h3.44V12H9.72v2.88h3.44Zm8.28,0h3.44V12H21.44Zm5.8,0h3.28V21.24a48.644,48.644,0,0,0-.44-4.96h.08c.4,1,.8,2.04,1.24,2.92L34.28,25H37.8V12H34.52v3.76a46.68,46.68,0,0,0,.44,4.96h-.08c-.4-1-.8-2.04-1.24-2.92L30.76,12H27.24Zm18.92.24a6.567,6.567,0,0,0,4.4-1.6v-6.2H45.6v2.8h1.92v1.8a1.948,1.948,0,0,1-1,.24c-2.32,0-3.4-1.36-3.4-3.8,0-2.36,1.32-3.76,3.08-3.76a3.177,3.177,0,0,1,2.32.84l1.8-2.08a5.708,5.708,0,0,0-4.24-1.72c-3.48,0-6.48,2.48-6.48,6.84C39.6,23.04,42.52,25.24,46.16,25.24Z"
                transform="translate(1371 119.491)"
                fill="#2aa4dd"
              />
              <path
                id="Path_11603"
                data-name="Path 11603"
                d="M-42.12,0h3.08V-3.84c0-1.32-.28-3.72-.44-5.04h.08l1.04,3.52,1.6,4.3h1.84l1.6-4.3,1.08-3.52h.08c-.16,1.32-.44,3.72-.44,5.04V0h3.12V-13h-3.68l-1.88,5.32c-.24.72-.44,1.52-.68,2.28h-.08c-.24-.76-.44-1.56-.68-2.28L-38.44-13h-3.68Zm15,0h8.6V-2.88h-5.16V-5.2h4.24V-8.08h-4.24v-2.04h4.96V-13h-8.4Zm13.96-6.32c.32-1.24.64-2.8.92-4.12h.08c.32,1.3.64,2.88.96,4.12l.22.9h-2.4Zm-5,6.32h3.52L-14-2.76h3.64L-9.72,0h3.64l-3.96-13H-14.2ZM-1.24.24C2,.24,3.84-1.72,3.84-3.92A3.573,3.573,0,0,0,1.3-7.48L-.28-8.1C-1.46-8.56-2.2-8.78-2.2-9.4c0-.58.52-.88,1.36-.88a4.655,4.655,0,0,1,2.52.92l1.8-2.24A6.433,6.433,0,0,0-.84-13.24c-2.84,0-4.84,1.82-4.84,4.04A3.841,3.841,0,0,0-3.06-5.58l1.62.68c1.1.44,1.76.64,1.76,1.26,0,.58-.44.92-1.48.92a5.249,5.249,0,0,1-3.2-1.16l-1.8,2.24A7.112,7.112,0,0,0-1.24.24Zm11.96,0c3.64,0,5.32-2.08,5.32-6.52V-13H12.72v7.12c0,2.32-.64,3.16-2,3.16S8.76-3.56,8.76-5.88V-13H5.32v6.72C5.32-1.84,7.08.24,10.72.24ZM18.32,0h3.44V-4.36h1.32L25.32,0h3.84L26.34-5.04a3.988,3.988,0,0,0,2.1-3.76c0-3.24-2.4-4.2-5.2-4.2H18.32Zm3.44-7.08v-3.2H23c1.36,0,2.08.36,2.08,1.48S24.36-7.08,23-7.08ZM30.4,0H39V-2.88H33.84V-5.2h4.24V-8.08H33.84v-2.04H38.8V-13H30.4ZM-36.4,25h3.44V20.64h1.32L-29.4,25h3.84l-2.82-5.04a3.988,3.988,0,0,0,2.1-3.76c0-3.24-2.4-4.2-5.2-4.2H-36.4Zm3.44-7.08v-3.2h1.24c1.36,0,2.08.36,2.08,1.48s-.72,1.72-2.08,1.72ZM-24.32,25h8.6V22.12h-5.16V19.8h4.24V16.92h-4.24V14.88h4.96V12h-8.4Zm14.72.24c3.24,0,5.08-1.96,5.08-4.16a3.573,3.573,0,0,0-2.54-3.56l-1.58-.62c-1.18-.46-1.92-.68-1.92-1.3,0-.58.52-.88,1.36-.88a4.655,4.655,0,0,1,2.52.92l1.8-2.24A6.433,6.433,0,0,0-9.2,11.76c-2.84,0-4.84,1.82-4.84,4.04a3.841,3.841,0,0,0,2.62,3.62l1.62.68c1.1.44,1.76.64,1.76,1.26,0,.58-.44.92-1.48.92a5.249,5.249,0,0,1-3.2-1.16l-1.8,2.24A7.112,7.112,0,0,0-9.6,25.24Zm11.96,0c3.64,0,5.32-2.08,5.32-6.52V12H4.36v7.12c0,2.32-.64,3.16-2,3.16S.4,21.44.4,19.12V12H-3.04v6.72C-3.04,23.16-1.28,25.24,2.36,25.24ZM9.96,25h8.36V22.12H13.4V12H9.96Zm10.16,0h3.44V14.88H27V12H16.68v2.88h3.44Zm12,.24c3.24,0,5.08-1.96,5.08-4.16a3.573,3.573,0,0,0-2.54-3.56l-1.58-.62c-1.18-.46-1.92-.68-1.92-1.3,0-.58.52-.88,1.36-.88a4.655,4.655,0,0,1,2.52.92l1.8-2.24a6.433,6.433,0,0,0-4.32-1.64c-2.84,0-4.84,1.82-4.84,4.04a3.841,3.841,0,0,0,2.62,3.62l1.62.68c1.1.44,1.76.64,1.76,1.26,0,.58-.44.92-1.48.92A5.249,5.249,0,0,1,29,21.12l-1.8,2.24A7.112,7.112,0,0,0,32.12,25.24Z"
                transform="translate(1549 138.843)"
                fill="#2aa4dd"
              />
            </g>
          </svg>

          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="100%"
            viewBox="0 0 1439.829 304.001"
          >
            <g
              id="Group_2421"
              data-name="Group 2421"
              transform="translate(0.07 -1328.576)"
            >
              <g id="Group_2420" data-name="Group 2420">
                <path
                  id="Path_14974"
                  data-name="Path 14974"
                  d="M11865-1493.791s975.553,137.978,1439.616,0"
                  transform="translate(-11865 2900)"
                  fill="none"
                  stroke="#707070"
                  strokeWidth={1}
                />
                <g id="Group_1298" data-name="Group 1298">
                  <path
                    id="Path_458"
                    data-name="Path 458"
                    d="M94.489,90.552,72.835,0,0,33.465Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 906.814, 1510.976)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_459"
                    data-name="Path 459"
                    d="M21.654,0,1.969,39.37,0,3.937Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 950.076, 1448.534)"
                    fill="#29a5de"
                  />
                  <path
                    id="Path_460"
                    data-name="Path 460"
                    d="M28.543,9.843,19.685,40.355,0,0Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 745.689, 1526.524)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_461"
                    data-name="Path 461"
                    d="M31.5,15.748,0,0,17.716,41.339Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 991.689, 1534.051)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_463"
                    data-name="Path 463"
                    d="M126.969,47.244l-74.8,51.182L0,0Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 1136.739, 1503.613)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_464"
                    data-name="Path 464"
                    d="M69.882,64.961,34.449,0,0,116.143Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 1131.655, 1384.883)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_465"
                    data-name="Path 465"
                    d="M28.543,5.905l-6.89,21.654L0,0Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 1094.8, 1433.1)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_467"
                    data-name="Path 467"
                    d="M16.732,21.654,13.78,0,0,28.543Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 762.227, 1452.442)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_468"
                    data-name="Path 468"
                    d="M46.938,0,35.521,54.55,0,57.087Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 803.551, 1406.313)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_472"
                    data-name="Path 472"
                    d="M51.181,14.764,0,0,16.732,77.757Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 649.932, 1389.07)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_473"
                    data-name="Path 473"
                    d="M110.237,0,89.568,182.088,0,75.788Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 533.469, 1465.183)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_474"
                    data-name="Path 474"
                    d="M6.016,0,40.608,23.312,0,71.441Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 562.406, 1511.466)"
                    fill="#29a5de"
                  />
                  <path
                    id="Path_475"
                    data-name="Path 475"
                    d="M29.528,24.606,47.245,0,0,4.921Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 663.109, 1472.899)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_476"
                    data-name="Path 476"
                    d="M19.685,8.858,12.8,38.386,0,0Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 803.364, 1615.359)"
                    fill="#29a5de"
                  />
                  <path
                    id="Path_477"
                    data-name="Path 477"
                    d="M17.716,10.827,1.969,0,0,41.339Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 495.553, 1403.653)"
                    fill="#efefef"
                  />
                  <path
                    id="Path_479"
                    data-name="Path 479"
                    d="M35.433,0,0,6.89,23.622,42.323Z"
                    transform="matrix(-0.485, 0.875, -0.875, -0.485, 848.702, 1408.096)"
                    fill="#efefef"
                  />
                </g>
                <g
                  id="Ellipse_140"
                  data-name="Ellipse 140"
                  transform="translate(318 1381)"
                  fill="#fff"
                  stroke="#b2b2b2"
                  strokeWidth={9}
                >
                  <circle cx={85} cy={85} r={85} stroke="none" />
                  <circle cx={85} cy={85} r={80.5} fill="none" />
                </g>
                <g
                  id="Ellipse_141"
                  data-name="Ellipse 141"
                  transform="translate(638 1381)"
                  fill="#fff"
                  stroke="#b2b2b2"
                  strokeWidth={9}
                >
                  <ellipse cx={85.5} cy={85} rx={85.5} ry={85} stroke="none" />
                  <ellipse cx={85.5} cy={85} rx={81} ry={80.5} fill="none" />
                </g>
                <g
                  id="Ellipse_142"
                  data-name="Ellipse 142"
                  transform="translate(953 1381)"
                  fill="#fff"
                  stroke="#b2b2b2"
                  strokeWidth={9}
                >
                  <circle cx={85} cy={85} r={85} stroke="none" />
                  <circle cx={85} cy={85} r={80.5} fill="none" />
                </g>
                <path
                  id="Path_14976"
                  data-name="Path 14976"
                  d="M-23.448,0h2.737V-6.233h5.428v-2.3h-5.428v-4.209h6.371v-2.3h-9.108Zm10.9,0h2.737V-11.316h-2.737Zm1.38-13.248a1.511,1.511,0,0,0,1.633-1.541,1.511,1.511,0,0,0-1.633-1.541A1.511,1.511,0,0,0-12.8-14.789,1.511,1.511,0,0,0-11.167-13.248ZM-8.429,0H-5.6l1.15-2.208c.345-.667.667-1.357,1.012-2h.092c.368.644.759,1.334,1.127,2L-.862,0H2.059L-1.506-5.589l3.335-5.727H-1L-2.035-9.2c-.3.644-.6,1.288-.9,1.909h-.092c-.322-.621-.69-1.265-1.012-1.909l-1.242-2.116H-8.2l3.335,5.428ZM7.763.276a6.571,6.571,0,0,0,3.91-1.2l-.92-1.7a4.743,4.743,0,0,1-2.622.782A3.157,3.157,0,0,1,4.865-4.83h7.13a6.081,6.081,0,0,0,.138-1.38c0-3.174-1.656-5.382-4.715-5.382C4.773-11.592,2.2-9.338,2.2-5.658,2.2-1.886,4.635.276,7.763.276Zm-2.9-7.13A2.7,2.7,0,0,1,7.487-9.476c1.472,0,2.254.966,2.254,2.622ZM18,.276a4.7,4.7,0,0,0,3.174-1.495h.092L21.471,0h2.208V-16.238H20.965v4.071l.115,1.817a4.156,4.156,0,0,0-2.944-1.242c-2.484,0-4.784,2.254-4.784,5.957C13.352-1.909,15.169.276,18,.276Zm.667-2.254c-1.61,0-2.53-1.265-2.53-3.7,0-2.323,1.173-3.657,2.576-3.657a3.194,3.194,0,0,1,2.254.92v5.2A2.868,2.868,0,0,1,18.665-1.978ZM-13.006,22.276a6.033,6.033,0,0,0,4.761-2.185l-1.472-1.633a4.105,4.105,0,0,1-3.174,1.449c-2.507,0-4.094-2.07-4.094-5.451,0-3.358,1.748-5.382,4.14-5.382a3.9,3.9,0,0,1,2.852,1.2l1.449-1.679a5.886,5.886,0,0,0-4.347-1.909c-3.818,0-6.9,2.921-6.9,7.843C-19.791,19.516-16.778,22.276-13.006,22.276Zm11.086,0c2.806,0,5.382-2.162,5.382-5.911,0-3.772-2.576-5.957-5.382-5.957-2.829,0-5.405,2.185-5.405,5.957C-7.325,20.114-4.749,22.276-1.92,22.276Zm0-2.208c-1.633,0-2.6-1.472-2.6-3.7,0-2.254.966-3.726,2.6-3.726s2.6,1.472,2.6,3.726C.679,18.6-.287,20.068-1.92,20.068ZM8.522,22.276c2.875,0,4.439-1.564,4.439-3.519s-1.541-2.852-3.289-3.45c-1.426-.483-2.231-.8-2.231-1.633,0-.667.506-1.219,1.633-1.219a4.12,4.12,0,0,1,2.53.874l1.173-1.541A5.712,5.712,0,0,0,9,10.408c-2.53,0-4.14,1.426-4.14,3.4,0,1.794,1.518,2.737,3.151,3.335,1.265.46,2.369.828,2.369,1.771,0,.759-.575,1.311-1.771,1.311a4.829,4.829,0,0,1-3.174-1.15l-1.2,1.541A6.3,6.3,0,0,0,8.522,22.276Zm9.729,0a5.73,5.73,0,0,0,2.346-.483l-.483-1.909a3.043,3.043,0,0,1-1.173.23c-1.058,0-1.587-.644-1.587-1.955V12.846h2.875V10.684H17.354V7.165H15.1l-.322,3.519-1.748.138v2.024h1.61v5.313C14.639,20.62,15.606,22.276,18.25,22.276ZM-27.278,44h2.484V37.146a42.667,42.667,0,0,0-.414-4.876h.092l1.2,3.634,2.392,6.716h1.794L-17.3,35.9l1.2-3.634h.092a42.667,42.667,0,0,0-.414,4.876V44h2.53V28.958h-3.22l-2.576,7.36c-.322.966-.552,1.84-.828,2.944h-.092c-.276-1.1-.552-1.978-.874-2.944l-2.576-7.36h-3.22Zm21,.276c2.806,0,5.382-2.162,5.382-5.911,0-3.772-2.576-5.957-5.382-5.957-2.829,0-5.405,2.185-5.405,5.957C-11.684,42.114-9.108,44.276-6.279,44.276Zm0-2.208c-1.633,0-2.6-1.472-2.6-3.7,0-2.254.966-3.726,2.6-3.726s2.6,1.472,2.6,3.726C-3.68,40.6-4.646,42.068-6.279,42.068ZM5.06,44.276a4.7,4.7,0,0,0,3.174-1.5h.092L8.533,44h2.208V27.762H8.027v4.071l.115,1.817A4.156,4.156,0,0,0,5.2,32.408c-2.484,0-4.784,2.254-4.784,5.957C.414,42.091,2.231,44.276,5.06,44.276Zm.667-2.254c-1.61,0-2.53-1.265-2.53-3.7C3.2,36,4.37,34.662,5.773,34.662a3.194,3.194,0,0,1,2.254.92v5.2A2.868,2.868,0,0,1,5.727,42.022Zm12.581,2.254a6.571,6.571,0,0,0,3.91-1.2l-.92-1.7a4.743,4.743,0,0,1-2.622.782,3.157,3.157,0,0,1-3.266-2.99h7.13a6.081,6.081,0,0,0,.138-1.38c0-3.174-1.656-5.382-4.715-5.382-2.645,0-5.221,2.254-5.221,5.934C12.742,42.114,15.18,44.276,18.308,44.276Zm-2.9-7.13a2.7,2.7,0,0,1,2.622-2.622c1.472,0,2.254.966,2.254,2.622Zm11.776,7.13a3.225,3.225,0,0,0,1.426-.253l-.322-2a1.419,1.419,0,0,1-.414.046c-.276,0-.575-.23-.575-.9V27.762H24.564V41.033C24.564,43.034,25.277,44.276,27.186,44.276Z"
                  transform="translate(403 1473)"
                  fill="#333"
                />
                <path
                  id="Path_14975"
                  data-name="Path 14975"
                  d="M-30.141,0H-27.4V-12.742h4.324v-2.3H-34.465v2.3h4.324Zm8.717,0h2.737V-11.316h-2.737Zm1.38-13.248a1.511,1.511,0,0,0,1.633-1.541,1.511,1.511,0,0,0-1.633-1.541,1.511,1.511,0,0,0-1.633,1.541A1.511,1.511,0,0,0-20.045-13.248ZM-15.973,0h2.737V-7.866a3.386,3.386,0,0,1,2.323-1.38c1.15,0,1.7.667,1.7,2.507V0H-6.5V-7.866a3.386,3.386,0,0,1,2.323-1.38c1.173,0,1.7.667,1.7,2.507V0H.264V-7.084c0-2.852-1.1-4.508-3.5-4.508-1.449,0-2.553.874-3.634,2.024a3.071,3.071,0,0,0-3.128-2.024,4.9,4.9,0,0,0-3.473,1.817h-.069l-.207-1.541h-2.231ZM7.694.276A6.571,6.571,0,0,0,11.6-.92l-.92-1.7a4.743,4.743,0,0,1-2.622.782A3.157,3.157,0,0,1,4.8-4.83h7.13a6.081,6.081,0,0,0,.138-1.38c0-3.174-1.656-5.382-4.715-5.382-2.645,0-5.221,2.254-5.221,5.934C2.128-1.886,4.566.276,7.694.276ZM4.8-6.854A2.7,2.7,0,0,1,7.418-9.476c1.472,0,2.254.966,2.254,2.622ZM21.1-11.569a1.7,1.7,0,0,1,1.587-1.909c.851,0,1.2.621,1.2,1.4,0,1.15-.966,1.909-2.185,2.668A4.807,4.807,0,0,1,21.1-11.569ZM21.77.276a7.075,7.075,0,0,0,4.554-1.61A11.951,11.951,0,0,0,29.981.276l.69-2.208a9.481,9.481,0,0,1-2.714-1.173,16.286,16.286,0,0,0,2.576-5.221H28.026A11.119,11.119,0,0,1,26.117-4.37a18.818,18.818,0,0,1-3.381-3.381C24.369-8.878,26-10.12,26-12.1a3.069,3.069,0,0,0-3.358-3.22,3.673,3.673,0,0,0-3.818,3.772,7.19,7.19,0,0,0,.966,3.312c-1.518.989-2.852,2.208-2.852,4.278C16.94-1.61,18.734.276,21.77.276ZM19.539-4.117a3.107,3.107,0,0,1,1.38-2.3,21.639,21.639,0,0,0,3.542,3.726,4.238,4.238,0,0,1-2.369.874A2.333,2.333,0,0,1,19.539-4.117ZM-36.593,22h2.484V15.146a42.668,42.668,0,0,0-.414-4.876h.092l1.2,3.634,2.392,6.716h1.794l2.438-6.716,1.2-3.634h.092a42.667,42.667,0,0,0-.414,4.876V22h2.53V6.958h-3.22L-29,14.318c-.322.966-.552,1.84-.828,2.944h-.092c-.276-1.1-.552-1.978-.874-2.944l-2.576-7.36h-3.22Zm19.09.276a5.268,5.268,0,0,0,3.45-1.518h.092l.23,1.242h2.208V15.307c0-3.151-1.426-4.9-4.232-4.9A8.834,8.834,0,0,0-20.4,11.88l.966,1.794a6.365,6.365,0,0,1,3.174-1.058c1.518,0,1.978.966,2.024,2.116-4.646.506-6.624,1.748-6.624,4.232A3.175,3.175,0,0,0-17.5,22.276Zm.828-2.162c-.92,0-1.564-.368-1.564-1.334,0-1.15.92-1.84,4-2.208v2.392A3.37,3.37,0,0,1-16.675,20.114Zm11.339,2.162a5.73,5.73,0,0,0,2.346-.483l-.483-1.909a3.043,3.043,0,0,1-1.173.23c-1.058,0-1.587-.644-1.587-1.955V12.846h2.875V10.684H-6.233V7.165H-8.487l-.322,3.519-1.748.138v2.024h1.61v5.313C-8.947,20.62-7.981,22.276-5.336,22.276Zm8.188,0a6.571,6.571,0,0,0,3.91-1.2l-.92-1.7a4.743,4.743,0,0,1-2.622.782A3.157,3.157,0,0,1-.046,17.17h7.13a6.081,6.081,0,0,0,.138-1.38c0-3.174-1.656-5.382-4.715-5.382-2.645,0-5.221,2.254-5.221,5.934C-2.714,20.114-.276,22.276,2.852,22.276Zm-2.9-7.13a2.7,2.7,0,0,1,2.622-2.622c1.472,0,2.254.966,2.254,2.622ZM9.108,22h2.737V15.146c.667-1.725,1.748-2.323,2.645-2.323a3.742,3.742,0,0,1,1.081.138l.552-2.323a3.227,3.227,0,0,0-1.288-.23,3.926,3.926,0,0,0-3.22,2.3h-.069l-.207-2.024H9.108Zm8.05,0h2.737V10.684H17.158Zm1.38-13.248a1.544,1.544,0,1,0,0-3.082,1.544,1.544,0,1,0,0,3.082Zm6.831,13.524a5.268,5.268,0,0,0,3.45-1.518h.092L29.141,22h2.208V15.307c0-3.151-1.426-4.9-4.232-4.9a8.834,8.834,0,0,0-4.646,1.472l.966,1.794a6.365,6.365,0,0,1,3.174-1.058c1.518,0,1.978.966,2.024,2.116-4.646.506-6.624,1.748-6.624,4.232A3.175,3.175,0,0,0,25.369,22.276Zm.828-2.162c-.92,0-1.564-.368-1.564-1.334,0-1.15.92-1.84,4-2.208v2.392A3.37,3.37,0,0,1,26.2,20.114Zm10.3,2.162a3.225,3.225,0,0,0,1.426-.253l-.322-2a1.419,1.419,0,0,1-.414.046c-.276,0-.575-.23-.575-.9V5.762H33.879V19.033C33.879,21.034,34.592,22.276,36.5,22.276ZM-27.278,44h2.484V37.146a42.667,42.667,0,0,0-.414-4.876h.092l1.2,3.634,2.392,6.716h1.794L-17.3,35.9l1.2-3.634h.092a42.667,42.667,0,0,0-.414,4.876V44h2.53V28.958h-3.22l-2.576,7.36c-.322.966-.552,1.84-.828,2.944h-.092c-.276-1.1-.552-1.978-.874-2.944l-2.576-7.36h-3.22Zm21,.276c2.806,0,5.382-2.162,5.382-5.911,0-3.772-2.576-5.957-5.382-5.957-2.829,0-5.405,2.185-5.405,5.957C-11.684,42.114-9.108,44.276-6.279,44.276Zm0-2.208c-1.633,0-2.6-1.472-2.6-3.7,0-2.254.966-3.726,2.6-3.726s2.6,1.472,2.6,3.726C-3.68,40.6-4.646,42.068-6.279,42.068ZM5.06,44.276a4.7,4.7,0,0,0,3.174-1.5h.092L8.533,44h2.208V27.762H8.027v4.071l.115,1.817A4.156,4.156,0,0,0,5.2,32.408c-2.484,0-4.784,2.254-4.784,5.957C.414,42.091,2.231,44.276,5.06,44.276Zm.667-2.254c-1.61,0-2.53-1.265-2.53-3.7C3.2,36,4.37,34.662,5.773,34.662a3.194,3.194,0,0,1,2.254.92v5.2A2.868,2.868,0,0,1,5.727,42.022Zm12.581,2.254a6.571,6.571,0,0,0,3.91-1.2l-.92-1.7a4.743,4.743,0,0,1-2.622.782,3.157,3.157,0,0,1-3.266-2.99h7.13a6.081,6.081,0,0,0,.138-1.38c0-3.174-1.656-5.382-4.715-5.382-2.645,0-5.221,2.254-5.221,5.934C12.742,42.114,15.18,44.276,18.308,44.276Zm-2.9-7.13a2.7,2.7,0,0,1,2.622-2.622c1.472,0,2.254.966,2.254,2.622Zm11.776,7.13a3.225,3.225,0,0,0,1.426-.253l-.322-2a1.419,1.419,0,0,1-.414.046c-.276,0-.575-.23-.575-.9V27.762H24.564V41.033C24.564,43.034,25.277,44.276,27.186,44.276Z"
                  transform="translate(724 1473)"
                  fill="#333"
                />
                <path
                  id="Path_14977"
                  data-name="Path 14977"
                  d="M-30.13,0h2.737V-6.624h5.98V0h2.737V-15.042h-2.737v6.026h-5.98v-6.026H-30.13Zm19.09.276c2.806,0,5.382-2.162,5.382-5.911,0-3.772-2.576-5.957-5.382-5.957-2.829,0-5.405,2.185-5.405,5.957C-16.445-1.886-13.869.276-11.04.276Zm0-2.208c-1.633,0-2.6-1.472-2.6-3.7,0-2.254.966-3.726,2.6-3.726s2.6,1.472,2.6,3.726C-8.441-3.4-9.407-1.932-11.04-1.932ZM-.322.276A4.569,4.569,0,0,0,3.312-1.656h.069L3.588,0H5.819V-11.316H3.1v7.728C2.277-2.507,1.633-2.047.644-2.047c-1.2,0-1.725-.69-1.725-2.53v-6.739H-3.8v7.084C-3.8-1.38-2.737.276-.322.276ZM8.556,0h2.737V-6.854c.667-1.725,1.748-2.323,2.645-2.323a3.742,3.742,0,0,1,1.081.138l.552-2.323a3.227,3.227,0,0,0-1.288-.23,3.926,3.926,0,0,0-3.22,2.3h-.069l-.207-2.024H8.556ZM19.228.276A3.225,3.225,0,0,0,20.654.023l-.322-2a1.419,1.419,0,0,1-.414.046c-.276,0-.575-.23-.575-.9V-16.238H16.606V-2.967C16.606-.966,17.319.276,19.228.276Zm3.841,4.347c2.484,0,3.68-1.564,4.623-4.14l4.071-11.8H29.141l-1.656,5.5c-.276,1.035-.575,2.139-.851,3.2h-.092c-.322-1.081-.644-2.208-.989-3.2l-1.909-5.5h-2.76L25.323-.161l-.207.713a2.342,2.342,0,0,1-2.231,1.886,2.572,2.572,0,0,1-.782-.115L21.574,4.37A4.058,4.058,0,0,0,23.069,4.623ZM-29.014,22h5.221c3.312,0,5.8-1.4,5.8-4.416a3.435,3.435,0,0,0-2.875-3.565v-.092a3.4,3.4,0,0,0,2.07-3.266c0-2.76-2.277-3.7-5.382-3.7h-4.83Zm2.737-8.855V9.1h1.909c1.932,0,2.9.529,2.9,1.955,0,1.288-.9,2.093-2.944,2.093Zm0,6.716V15.192h2.208c2.208,0,3.381.69,3.381,2.231,0,1.679-1.2,2.438-3.381,2.438Zm12.926,2.415A5.268,5.268,0,0,0-9.9,20.758h.092L-9.58,22h2.208V15.307c0-3.151-1.426-4.9-4.232-4.9A8.834,8.834,0,0,0-16.25,11.88l.966,1.794a6.365,6.365,0,0,1,3.174-1.058c1.518,0,1.978.966,2.024,2.116-4.646.506-6.624,1.748-6.624,4.232A3.175,3.175,0,0,0-13.351,22.276Zm.828-2.162c-.92,0-1.564-.368-1.564-1.334,0-1.15.92-1.84,4-2.208v2.392A3.37,3.37,0,0,1-12.524,20.114Zm10.856,2.162c2.875,0,4.439-1.564,4.439-3.519s-1.541-2.852-3.289-3.45c-1.426-.483-2.231-.8-2.231-1.633,0-.667.506-1.219,1.633-1.219a4.12,4.12,0,0,1,2.53.874l1.173-1.541a5.712,5.712,0,0,0-3.772-1.38c-2.53,0-4.14,1.426-4.14,3.4,0,1.794,1.518,2.737,3.151,3.335C-.908,17.607.2,17.975.2,18.918c0,.759-.575,1.311-1.771,1.311a4.829,4.829,0,0,1-3.174-1.15l-1.2,1.541A6.3,6.3,0,0,0-1.667,22.276Zm10.994,0a6.571,6.571,0,0,0,3.91-1.2l-.92-1.7a4.743,4.743,0,0,1-2.622.782,3.157,3.157,0,0,1-3.266-2.99h7.13a6.081,6.081,0,0,0,.138-1.38c0-3.174-1.656-5.382-4.715-5.382-2.645,0-5.221,2.254-5.221,5.934C3.76,20.114,6.2,22.276,9.326,22.276Zm-2.9-7.13A2.7,2.7,0,0,1,9.05,12.524c1.472,0,2.254.966,2.254,2.622Zm13.133,7.13a4.7,4.7,0,0,0,3.174-1.495h.092L23.034,22h2.208V5.762H22.528V9.833l.115,1.817A4.156,4.156,0,0,0,19.7,10.408c-2.484,0-4.784,2.254-4.784,5.957C14.915,20.091,16.732,22.276,19.561,22.276Zm.667-2.254c-1.61,0-2.53-1.265-2.53-3.7,0-2.323,1.173-3.657,2.576-3.657a3.194,3.194,0,0,1,2.254.92v5.2A2.868,2.868,0,0,1,20.228,20.022ZM-27.278,44h2.484V37.146a42.667,42.667,0,0,0-.414-4.876h.092l1.2,3.634,2.392,6.716h1.794L-17.3,35.9l1.2-3.634h.092a42.667,42.667,0,0,0-.414,4.876V44h2.53V28.958h-3.22l-2.576,7.36c-.322.966-.552,1.84-.828,2.944h-.092c-.276-1.1-.552-1.978-.874-2.944l-2.576-7.36h-3.22Zm21,.276c2.806,0,5.382-2.162,5.382-5.911,0-3.772-2.576-5.957-5.382-5.957-2.829,0-5.405,2.185-5.405,5.957C-11.684,42.114-9.108,44.276-6.279,44.276Zm0-2.208c-1.633,0-2.6-1.472-2.6-3.7,0-2.254.966-3.726,2.6-3.726s2.6,1.472,2.6,3.726C-3.68,40.6-4.646,42.068-6.279,42.068ZM5.06,44.276a4.7,4.7,0,0,0,3.174-1.5h.092L8.533,44h2.208V27.762H8.027v4.071l.115,1.817A4.156,4.156,0,0,0,5.2,32.408c-2.484,0-4.784,2.254-4.784,5.957C.414,42.091,2.231,44.276,5.06,44.276Zm.667-2.254c-1.61,0-2.53-1.265-2.53-3.7C3.2,36,4.37,34.662,5.773,34.662a3.194,3.194,0,0,1,2.254.92v5.2A2.868,2.868,0,0,1,5.727,42.022Zm12.581,2.254a6.571,6.571,0,0,0,3.91-1.2l-.92-1.7a4.743,4.743,0,0,1-2.622.782,3.157,3.157,0,0,1-3.266-2.99h7.13a6.081,6.081,0,0,0,.138-1.38c0-3.174-1.656-5.382-4.715-5.382-2.645,0-5.221,2.254-5.221,5.934C12.742,42.114,15.18,44.276,18.308,44.276Zm-2.9-7.13a2.7,2.7,0,0,1,2.622-2.622c1.472,0,2.254.966,2.254,2.622Zm11.776,7.13a3.225,3.225,0,0,0,1.426-.253l-.322-2a1.419,1.419,0,0,1-.414.046c-.276,0-.575-.23-.575-.9V27.762H24.564V41.033C24.564,43.034,25.277,44.276,27.186,44.276Z"
                  transform="translate(1038 1473)"
                  fill="#333"
                />
                <path
                  id="Path_14980"
                  data-name="Path 14980"
                  d="M12.079-.39a11.79,11.79,0,0,0,4.472-.835A7.774,7.774,0,0,0,19.872-3.7a6.427,6.427,0,0,0,1.262-4.036v-.037A5.577,5.577,0,0,0,19.2-12.3a13.357,13.357,0,0,0-5.511-2.468l-2.765-.668a8.715,8.715,0,0,1-2.561-.983A3.806,3.806,0,0,1,7-17.775a3.377,3.377,0,0,1-.417-1.651v-.037A3.4,3.4,0,0,1,7.208-21.4a4.5,4.5,0,0,1,1.846-1.5,7,7,0,0,1,3.024-.584,6.831,6.831,0,0,1,2.728.52,4.8,4.8,0,0,1,1.958,1.5,4.537,4.537,0,0,1,.881,2.394v.037l3.229-.019v-.019a6.725,6.725,0,0,0-1.28-3.85,8.052,8.052,0,0,0-3.164-2.551,10.2,10.2,0,0,0-4.351-.909,10.826,10.826,0,0,0-4.472.881A7.459,7.459,0,0,0,4.5-23.017a6.347,6.347,0,0,0-1.141,3.776v.037a5.834,5.834,0,0,0,.816,3.136,6.539,6.539,0,0,0,2.4,2.217,15.067,15.067,0,0,0,3.887,1.457l2.765.668a10.778,10.778,0,0,1,2.848,1.039A3.578,3.578,0,0,1,17.5-9.314a3.823,3.823,0,0,1,.408,1.8v.037a4.006,4.006,0,0,1-.575,2.106A3.93,3.93,0,0,1,15.484-3.85a8.386,8.386,0,0,1-3.368.566,8.031,8.031,0,0,1-3.349-.6A4.646,4.646,0,0,1,6.772-5.529,5.612,5.612,0,0,1,5.9-7.849v-.037l-3.229.019v.019a6.756,6.756,0,0,0,1.4,4.008A8.386,8.386,0,0,0,7.5-1.28,11.689,11.689,0,0,0,12.079-.39ZM10.892,2.69h2.227V-29.465H10.892ZM33.255-.39a11.79,11.79,0,0,0,4.472-.835A7.774,7.774,0,0,0,41.048-3.7,6.427,6.427,0,0,0,42.31-7.737v-.037A5.577,5.577,0,0,0,40.38-12.3a13.357,13.357,0,0,0-5.511-2.468L32.1-15.437a8.715,8.715,0,0,1-2.561-.983,3.806,3.806,0,0,1-1.364-1.354,3.377,3.377,0,0,1-.417-1.651v-.037a3.4,3.4,0,0,1,.622-1.939,4.5,4.5,0,0,1,1.846-1.5,7,7,0,0,1,3.024-.584,6.831,6.831,0,0,1,2.728.52,4.8,4.8,0,0,1,1.958,1.5,4.537,4.537,0,0,1,.881,2.394v.037l3.229-.019v-.019a6.725,6.725,0,0,0-1.28-3.85,8.052,8.052,0,0,0-3.164-2.551,10.2,10.2,0,0,0-4.351-.909,10.826,10.826,0,0,0-4.472.881,7.459,7.459,0,0,0-3.108,2.486,6.347,6.347,0,0,0-1.141,3.776v.037a5.834,5.834,0,0,0,.816,3.136,6.539,6.539,0,0,0,2.4,2.217,15.067,15.067,0,0,0,3.887,1.457l2.765.668a10.778,10.778,0,0,1,2.848,1.039,3.578,3.578,0,0,1,1.419,1.373,3.823,3.823,0,0,1,.408,1.8v.037a4.006,4.006,0,0,1-.575,2.106A3.93,3.93,0,0,1,36.66-3.85a8.386,8.386,0,0,1-3.368.566,8.031,8.031,0,0,1-3.349-.6,4.646,4.646,0,0,1-1.995-1.642,5.612,5.612,0,0,1-.872-2.319v-.037l-3.229.019v.019a6.756,6.756,0,0,0,1.4,4.008A8.386,8.386,0,0,0,28.672-1.28,11.689,11.689,0,0,0,33.255-.39ZM32.067,2.69h2.227V-29.465H32.067ZM54.431-.39A11.79,11.79,0,0,0,58.9-1.225,7.774,7.774,0,0,0,62.224-3.7a6.427,6.427,0,0,0,1.262-4.036v-.037a5.577,5.577,0,0,0-1.93-4.527,13.357,13.357,0,0,0-5.511-2.468l-2.765-.668a8.715,8.715,0,0,1-2.561-.983,3.806,3.806,0,0,1-1.364-1.354,3.377,3.377,0,0,1-.417-1.651v-.037A3.4,3.4,0,0,1,49.56-21.4a4.5,4.5,0,0,1,1.846-1.5,7,7,0,0,1,3.024-.584,6.831,6.831,0,0,1,2.728.52,4.8,4.8,0,0,1,1.958,1.5A4.537,4.537,0,0,1,60-19.074v.037l3.229-.019v-.019a6.725,6.725,0,0,0-1.28-3.85,8.052,8.052,0,0,0-3.164-2.551,10.2,10.2,0,0,0-4.351-.909,10.826,10.826,0,0,0-4.472.881,7.459,7.459,0,0,0-3.108,2.486,6.347,6.347,0,0,0-1.141,3.776v.037a5.834,5.834,0,0,0,.816,3.136,6.539,6.539,0,0,0,2.4,2.217,15.067,15.067,0,0,0,3.887,1.457l2.765.668a10.778,10.778,0,0,1,2.848,1.039,3.578,3.578,0,0,1,1.419,1.373,3.823,3.823,0,0,1,.408,1.8v.037a4.006,4.006,0,0,1-.575,2.106A3.93,3.93,0,0,1,57.835-3.85a8.386,8.386,0,0,1-3.368.566,8.031,8.031,0,0,1-3.349-.6,4.646,4.646,0,0,1-1.995-1.642,5.612,5.612,0,0,1-.872-2.319v-.037l-3.229.019v.019a6.756,6.756,0,0,0,1.4,4.008A8.386,8.386,0,0,0,49.848-1.28,11.689,11.689,0,0,0,54.431-.39ZM53.243,2.69H55.47V-29.465H53.243Z"
                  transform="translate(371 1443)"
                  fill="#29a5de"
                />
                <path
                  id="Path_14981"
                  data-name="Path 14981"
                  d="M12.079-.39a11.79,11.79,0,0,0,4.472-.835A7.774,7.774,0,0,0,19.872-3.7a6.427,6.427,0,0,0,1.262-4.036v-.037A5.577,5.577,0,0,0,19.2-12.3a13.357,13.357,0,0,0-5.511-2.468l-2.765-.668a8.715,8.715,0,0,1-2.561-.983A3.806,3.806,0,0,1,7-17.775a3.377,3.377,0,0,1-.417-1.651v-.037A3.4,3.4,0,0,1,7.208-21.4a4.5,4.5,0,0,1,1.846-1.5,7,7,0,0,1,3.024-.584,6.831,6.831,0,0,1,2.728.52,4.8,4.8,0,0,1,1.958,1.5,4.537,4.537,0,0,1,.881,2.394v.037l3.229-.019v-.019a6.725,6.725,0,0,0-1.28-3.85,8.052,8.052,0,0,0-3.164-2.551,10.2,10.2,0,0,0-4.351-.909,10.826,10.826,0,0,0-4.472.881A7.459,7.459,0,0,0,4.5-23.017a6.347,6.347,0,0,0-1.141,3.776v.037a5.834,5.834,0,0,0,.816,3.136,6.539,6.539,0,0,0,2.4,2.217,15.067,15.067,0,0,0,3.887,1.457l2.765.668a10.778,10.778,0,0,1,2.848,1.039A3.578,3.578,0,0,1,17.5-9.314a3.823,3.823,0,0,1,.408,1.8v.037a4.006,4.006,0,0,1-.575,2.106A3.93,3.93,0,0,1,15.484-3.85a8.386,8.386,0,0,1-3.368.566,8.031,8.031,0,0,1-3.349-.6A4.646,4.646,0,0,1,6.772-5.529,5.612,5.612,0,0,1,5.9-7.849v-.037l-3.229.019v.019a6.756,6.756,0,0,0,1.4,4.008A8.386,8.386,0,0,0,7.5-1.28,11.689,11.689,0,0,0,12.079-.39ZM10.892,2.69h2.227V-29.465H10.892ZM33.255-.39a11.79,11.79,0,0,0,4.472-.835A7.774,7.774,0,0,0,41.048-3.7,6.427,6.427,0,0,0,42.31-7.737v-.037A5.577,5.577,0,0,0,40.38-12.3a13.357,13.357,0,0,0-5.511-2.468L32.1-15.437a8.715,8.715,0,0,1-2.561-.983,3.806,3.806,0,0,1-1.364-1.354,3.377,3.377,0,0,1-.417-1.651v-.037a3.4,3.4,0,0,1,.622-1.939,4.5,4.5,0,0,1,1.846-1.5,7,7,0,0,1,3.024-.584,6.831,6.831,0,0,1,2.728.52,4.8,4.8,0,0,1,1.958,1.5,4.537,4.537,0,0,1,.881,2.394v.037l3.229-.019v-.019a6.725,6.725,0,0,0-1.28-3.85,8.052,8.052,0,0,0-3.164-2.551,10.2,10.2,0,0,0-4.351-.909,10.826,10.826,0,0,0-4.472.881,7.459,7.459,0,0,0-3.108,2.486,6.347,6.347,0,0,0-1.141,3.776v.037a5.834,5.834,0,0,0,.816,3.136,6.539,6.539,0,0,0,2.4,2.217,15.067,15.067,0,0,0,3.887,1.457l2.765.668a10.778,10.778,0,0,1,2.848,1.039,3.578,3.578,0,0,1,1.419,1.373,3.823,3.823,0,0,1,.408,1.8v.037a4.006,4.006,0,0,1-.575,2.106A3.93,3.93,0,0,1,36.66-3.85a8.386,8.386,0,0,1-3.368.566,8.031,8.031,0,0,1-3.349-.6,4.646,4.646,0,0,1-1.995-1.642,5.612,5.612,0,0,1-.872-2.319v-.037l-3.229.019v.019a6.756,6.756,0,0,0,1.4,4.008A8.386,8.386,0,0,0,28.672-1.28,11.689,11.689,0,0,0,33.255-.39ZM32.067,2.69h2.227V-29.465H32.067ZM44.5-9.277H64.135v-3.006H44.5Zm8.313,8.5h3.006v-20H52.816Zm22.79.39a11.79,11.79,0,0,0,4.472-.835A7.774,7.774,0,0,0,83.4-3.7a6.427,6.427,0,0,0,1.262-4.036v-.037a5.577,5.577,0,0,0-1.93-4.527,13.357,13.357,0,0,0-5.511-2.468l-2.765-.668a8.715,8.715,0,0,1-2.561-.983,3.806,3.806,0,0,1-1.364-1.354,3.377,3.377,0,0,1-.417-1.651v-.037a3.4,3.4,0,0,1,.622-1.939,4.5,4.5,0,0,1,1.846-1.5,7,7,0,0,1,3.024-.584,6.832,6.832,0,0,1,2.728.52,4.8,4.8,0,0,1,1.958,1.5,4.537,4.537,0,0,1,.881,2.394v.037l3.229-.019v-.019a6.725,6.725,0,0,0-1.28-3.85,8.052,8.052,0,0,0-3.164-2.551,10.2,10.2,0,0,0-4.351-.909,10.826,10.826,0,0,0-4.472.881,7.459,7.459,0,0,0-3.108,2.486,6.347,6.347,0,0,0-1.141,3.776v.037a5.834,5.834,0,0,0,.816,3.136,6.539,6.539,0,0,0,2.4,2.217,15.067,15.067,0,0,0,3.887,1.457l2.765.668a10.778,10.778,0,0,1,2.848,1.039,3.578,3.578,0,0,1,1.419,1.373,3.823,3.823,0,0,1,.408,1.8v.037a4.006,4.006,0,0,1-.575,2.106A3.93,3.93,0,0,1,79.011-3.85a8.386,8.386,0,0,1-3.368.566,8.031,8.031,0,0,1-3.349-.6A4.646,4.646,0,0,1,70.3-5.529a5.612,5.612,0,0,1-.872-2.319v-.037L66.2-7.867v.019a6.756,6.756,0,0,0,1.4,4.008A8.386,8.386,0,0,0,71.023-1.28,11.689,11.689,0,0,0,75.606-.39ZM74.419,2.69h2.227V-29.465H74.419Z"
                  transform="translate(681 1443)"
                  fill="#29a5de"
                />
                <path
                  id="Path_14982"
                  data-name="Path 14982"
                  d="M2.152-9.277H21.783v-3.006H2.152Zm8.313,8.5h3.006v-20H10.465Zm22.79.39a11.79,11.79,0,0,0,4.472-.835A7.774,7.774,0,0,0,41.048-3.7,6.427,6.427,0,0,0,42.31-7.737v-.037A5.577,5.577,0,0,0,40.38-12.3a13.357,13.357,0,0,0-5.511-2.468L32.1-15.437a8.715,8.715,0,0,1-2.561-.983,3.806,3.806,0,0,1-1.364-1.354,3.377,3.377,0,0,1-.417-1.651v-.037a3.4,3.4,0,0,1,.622-1.939,4.5,4.5,0,0,1,1.846-1.5,7,7,0,0,1,3.024-.584,6.831,6.831,0,0,1,2.728.52,4.8,4.8,0,0,1,1.958,1.5,4.537,4.537,0,0,1,.881,2.394v.037l3.229-.019v-.019a6.725,6.725,0,0,0-1.28-3.85,8.052,8.052,0,0,0-3.164-2.551,10.2,10.2,0,0,0-4.351-.909,10.826,10.826,0,0,0-4.472.881,7.459,7.459,0,0,0-3.108,2.486,6.347,6.347,0,0,0-1.141,3.776v.037a5.834,5.834,0,0,0,.816,3.136,6.539,6.539,0,0,0,2.4,2.217,15.067,15.067,0,0,0,3.887,1.457l2.765.668a10.778,10.778,0,0,1,2.848,1.039,3.578,3.578,0,0,1,1.419,1.373,3.823,3.823,0,0,1,.408,1.8v.037a4.006,4.006,0,0,1-.575,2.106A3.93,3.93,0,0,1,36.66-3.85a8.386,8.386,0,0,1-3.368.566,8.031,8.031,0,0,1-3.349-.6,4.646,4.646,0,0,1-1.995-1.642,5.612,5.612,0,0,1-.872-2.319v-.037l-3.229.019v.019a6.756,6.756,0,0,0,1.4,4.008A8.386,8.386,0,0,0,28.672-1.28,11.689,11.689,0,0,0,33.255-.39ZM32.067,2.69h2.227V-29.465H32.067Z"
                  transform="translate(1034 1443)"
                  fill="#29a5de"
                />
                <g id="clock" transform="translate(998 1414.107)">
                  <path
                    id="Path_14978"
                    data-name="Path 14978"
                    d="M16.447,30.837A14.391,14.391,0,1,0,2.056,16.447,14.391,14.391,0,0,0,16.447,30.837ZM32.893,16.447A16.447,16.447,0,1,1,16.447,0,16.447,16.447,0,0,1,32.893,16.447Z"
                    fill="#29a5de"
                    fillRule="evenodd"
                  />
                  <path
                    id="Path_14979"
                    data-name="Path 14979"
                    d="M16.778,6.75a1.028,1.028,0,0,1,1.028,1.028V18.489L24.483,22.3a1.028,1.028,0,0,1-1.02,1.784l-7.2-4.112a1.028,1.028,0,0,1-.518-.893V7.778A1.028,1.028,0,0,1,16.778,6.75Z"
                    transform="translate(-1.359 -0.583)"
                    fill="#29a5de"
                    fillRule="evenodd"
                  />
                </g>
              </g>
            </g>
          </svg>
        </div>

        <BrandOne />
        <BlogOne />
        <CtaLayoutOne />
        <FooterOne parentClass="" />
      </main>
    </>
  );
};

export default CreativeAgency;
